import axiosInstance from '../../../config/axiosInstance';
import type {
  CostResultListResponse,
  CostRun,
  CostRunListResponse,
  CreateDirectCostCategoryPayload,
  CreateDirectCostPayload,
  CreateDirectMaterialEntryPayload,
  CreateDirectMaterialPayload,
  CreateDirectMaterialValuationPayload,
  CreateFinalAllocationRulePayload,
  CreateInventoryCountPayload,
  CreatePrimaryAllocationPayload,
  CreateProductionReportIdlePeriodPayload,
  CreateProductionReportLinePayload,
  CreateProductionReportPayload,
  CreateProductionReportStopPayload,
  CreateProductionVolumePayload,
  UpdateProductionVolumePayload,
  CreateProductPayload,
  CreateSecondaryAllocationPayload,
  CreateStagePayload,
  CreateStageProductApplicabilityPayload,
  CreateTechnicalConsumptionRulePayload,
  CurrentCostResultListResponse,
  DirectCost,
  DirectCostBlockSummaryListResponse,
  DirectCostBlockUpsertResponse,
  DirectCostCategory,
  DirectCostCategoryListResponse,
  DirectCostListResponse,
  DirectMaterial,
  DirectMaterialImportConfirmResponse,
  DirectMaterialImportPreviewResponse,
  DirectMaterialEntry,
  DirectMaterialEntryImportConfirmResponse,
  DirectMaterialEntryImportPreviewResponse,
  DirectMaterialEntryListResponse,
  DirectMaterialMonthlyValuationListResponse,
  DirectMaterialValuation,
  MaterialControlResponse,
  MaterialStockProjectionResponse,
  DirectMaterialValuationListResponse,
  EconomicMovementListResponse,
  ExecuteCostRunPayload,
  FinalAllocationRule,
  FinalAllocationRuleListResponse,
  IndustrialCostModuleContext,
  InventoryCount,
  InventoryCountListResponse,
  InventoryCountPreviousResponse,
  InventoryCountSuggestionsResponse,
  InventoryImportConfirmResponse,
  InventoryImportPreviewResponse,
  MovementClassification,
  MovementClassificationListResponse,
  MovementImportImpactSummary,
  MovementUploadMode,
  PrimaryAllocation,
  PrimaryAllocationListResponse,
  ProductImportConfirmResponse,
  ProductImportPreviewResponse,
  ProductListResponse,
  ImportedManufacturingOrderImportConfirmResponse,
  ImportedManufacturingOrderImportCorrection,
  ImportedManufacturingOrderImportPreviewResponse,
  PurchaseOrderImportConfirmResponse,
  PurchaseOrderImportPreviewResponse,
  ProductionImportPreview,
  ProductionImportSummary,
  ProductionPlanningContext,
  ProductionPlanningWeekContext,
  ProductionPlanGroupScheduleAdjustmentPayload,
  ProductionPlanGroupMoveToLockedStartPayload,
  ProductionPlanGroupResolveLockedStartConflictPayload,
  ProductionPlanGroupUnplanPayload,
  ProductionPlanItem,
  ProductionPlanLineDaySettings,
  UpsertProductionPlanLineDaySettingsPayload,
  CreateProductionPlanItemPayload,
  UpdateProductionPlanItemPayload,
  ProductionReport,
  ProductionReportDetail,
  AcknowledgePlantNoticePayload,
  CreatePlantNoticePayload,
  PlantNotice,
  UpdatePlantNoticePayload,
  ExistingProductionOrderCandidate,
  ExistingProductionOrderLookup,
  ExistingProductionOrderSearchItem,
  ProductionReportFactoryControlItem,
  ProductionReportFactorySummary,
  ProductionReportWeeklyActivityResponse,
  ProductionReportPerformanceProductsResponse,
  ProductionReportReviewBoardItem,
  ProductionReportReviewBoardSummary,
  ProductionReportIdlePeriod,
  ProductionReportLine,
  ProductionReportOperatorContext,
  ProductionReportQualityResultRow,
  ProductionReportStop,
  ProductionLineConfig,
  ProductionMaterialLot,
  CreateProductionMaterialLotPayload,
  UpdateProductionMaterialLotPayload,
  ProductionLineGroup,
  ProductionShiftConfig,
  ProductionReportStopReason,
  ProductionReportQualityControl,
  CreatePlantUserPayload,
  PlantUser,
  ResetPlantUserPasswordPayload,
  UpdatePlantUserPayload,
  UpsertProductionLineConfigPayload,
  UpsertProductionLineGroupPayload,
  UpsertProductionReportQualityControlPayload,
  UpsertProductionReportStopReasonPayload,
  UpsertProductionShiftConfigPayload,
  ReopenProductionReportPayload,
  ProductionUploadMode,
  PanelProductionRow,
  ProductionVolume,
  ProductionVolumeListResponse,
  SecondaryAllocation,
  SecondaryAllocationListResponse,
  StageListResponse,
  StageProductApplicability,
  StageProductApplicabilityListResponse,
  TechnicalConsumptionImportConfirmResponse,
  TechnicalConsumptionImportPending,
  TechnicalConsumptionImportPendingListResponse,
  TechnicalConsumptionImportPreviewResponse,
  TechnicalConsumptionRule,
  ResolveTechnicalConsumptionImportPendingPayload,
  UpdateTechnicalConsumptionRulePayload,
  UpdateDirectCostCategoryPayload,
  UpdateDirectMaterialEntryPayload,
  UpdateDirectMaterialPayload,
  UpdateDirectMaterialValuationPayload,
  UpdateInventoryCountPayload,
  UpdateProductionReportIdlePeriodPayload,
  UpdateProductionReportLinePayload,
  UpdateProductionReportOperatorNumberPayload,
  UpdateProductionReportPayload,
  UpdateProductionReportStopPayload,
  UpdateProductPayload,
  UpdateStagePayload,
  UploadListResponse,
  UpsertDirectCostBlockPayload,
  UpsertProductionReportQualityResultPayload,
  ApplyDirectMaterialDerivationResponse,
  ApplyDirectMaterialDerivationPayload,
  DirectMaterialDerivationResponse,
  ProductionEstimationConfig,
  ProductionOperationSettings,
  UpdateProductionOperationSettingsPayload,
  LaborModuleConfig,
  UpdateLaborModuleConfigPayload,
  LaborStageCost,
  LaborStageCostListResponse,
  CreateLaborStageCostPayload,
  UpdateLaborStageCostPayload,
  LaborProductRate,
  LaborProductRateListResponse,
  CreateLaborProductRatePayload,
  UpdateLaborProductRatePayload,
  LaborProductRateImportPreviewResponse,
  LaborProductRateImportConfirmResponse,
  LaborResultSummary,
  CreateWarehouseMapPayload,
  CreateWarehousePayload,
  ReplaceWarehouseMapCellsPayload,
  UpdateWarehouseMapPayload,
  UpdateWarehousePayload,
  Warehouse,
  WarehouseMap,
  WarehouseMapActivateResponse,
  WarehouseMapCellsReplaceResponse,
  WarehouseMapDetailResponse,
  UpsertWarehouseLocationMaterialAssignmentPayload,
  WarehouseLocationMaterialAssignment,
} from '../types/industrialCost';
/**
 * Nota importante:
 * No consta aún verificado aquí el contrato exacto de respuesta de todos los endpoints.
 * Por eso se tipa de forma estricta solo lo que ya está razonablemente alineado con lo definido.
 * Si al conectar con backend aparece alguna desalineación real, deberá ajustarse sobre contrato verificado.
 */

export async function getIndustrialCostContext(): Promise<IndustrialCostModuleContext> {
  const { data } = await axiosInstance.get('/industrial-costs/context');
  return data as IndustrialCostModuleContext;
}

// =========================================================
// Production reports / Partes de producción
// =========================================================

export async function getIndustrialCostProductionReportOperatorContext(params?: {
  template_id?: string | null;
  shift?: string | null;
}): Promise<ProductionReportOperatorContext> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/operator-context',
    {
      params: {
        template_id: params?.template_id || undefined,
        shift: params?.shift || undefined,
      },
    },
  );

  return data as ProductionReportOperatorContext;
}

export async function listIndustrialCostPlantNotices(params?: {
  status_filter?: 'active' | 'archived' | 'all' | null;
  report_id?: string | null;
}): Promise<PlantNotice[]> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/plant-notices',
    {
      params: {
        status_filter: params?.status_filter || undefined,
        report_id: params?.report_id || undefined,
      },
    },
  );

  return data as PlantNotice[];
}

export async function createIndustrialCostPlantNotice(
  payload: CreatePlantNoticePayload,
): Promise<PlantNotice> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/plant-notices',
    payload,
  );

  return data as PlantNotice;
}

export async function updateIndustrialCostPlantNotice(
  noticeId: string,
  payload: UpdatePlantNoticePayload,
): Promise<PlantNotice> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/plant-notices/${noticeId}`,
    payload,
  );

  return data as PlantNotice;
}

export async function archiveIndustrialCostPlantNotice(
  noticeId: string,
): Promise<PlantNotice> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/plant-notices/${noticeId}`,
  );

  return data as PlantNotice;
}

export async function acknowledgeIndustrialCostPlantNotice(
  noticeId: string,
  payload: AcknowledgePlantNoticePayload,
): Promise<PlantNotice> {
  const { data } = await axiosInstance.post(
    `/industrial-costs/plant-notices/${noticeId}/acknowledge`,
    payload,
  );

  return data as PlantNotice;
}

export async function createIndustrialCostProductionReport(
  payload: CreateProductionReportPayload,
): Promise<ProductionReport> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/production-reports',
    payload,
  );

  return data as ProductionReport;
}

export async function listIndustrialCostProductionReports(params?: {
  report_date?: string | null;
  status_filter?: 'draft' | 'validated' | 'exported' | null;
}): Promise<ProductionReport[]> {
  const { data } = await axiosInstance.get('/industrial-costs/production-reports', {
    params: {
      report_date: params?.report_date || undefined,
      status_filter: params?.status_filter || undefined,
    },
  });

  return data as ProductionReport[];
}

export async function getIndustrialCostProductionReportFactoryControl(params?: {
  report_date?: string | null;
  shift?: string | null;
  status_filter?: 'draft' | 'validated' | 'exported' | null;
}): Promise<ProductionReportFactoryControlItem[]> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/factory-control',
    {
      params: {
        report_date: params?.report_date || undefined,
        shift: params?.shift || undefined,
        status_filter: params?.status_filter || undefined,
      },
    },
  );

  return data as ProductionReportFactoryControlItem[];
}

export async function getIndustrialCostProductionReportFactorySummary(params: {
  date_from: string;
  date_to: string;
  shift?: string | null;
  production_line_config_id?: string | null;
}): Promise<ProductionReportFactorySummary> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/factory-summary',
    {
      params: {
        date_from: params.date_from,
        date_to: params.date_to,
        shift: params.shift || undefined,
        production_line_config_id: params.production_line_config_id || undefined,
      },
    },
  );

  return data as ProductionReportFactorySummary;
}

export async function getIndustrialCostProductionReportWeeklyActivity(params: {
  date_from: string;
  date_to: string;
  as_of: string;
}): Promise<ProductionReportWeeklyActivityResponse> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/weekly-activity',
    {
      params,
    },
  );

  return data as ProductionReportWeeklyActivityResponse;
}

export async function getIndustrialCostProductionPerformanceProducts(params: {
  date_from: string;
  date_to: string;
  production_line_config_id?: string | null;
}): Promise<ProductionReportPerformanceProductsResponse> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-performance/products',
    {
      params: {
        date_from: params.date_from,
        date_to: params.date_to,
        production_line_config_id:
          params.production_line_config_id || undefined,
      },
    },
  );

  return data as ProductionReportPerformanceProductsResponse;
}

export async function getIndustrialCostProductionReportReviewBoard(params?: {
  review_status?:
    | 'all'
    | 'unvalidated'
    | 'pending_administrative_action'
    | 'pending_revalidation'
    | 'validated'
    | 'exported'
    | null;
  shift?: string | null;
  production_line_config_id?: string | null;
  date_from?: string | null;
  date_to?: string | null;
  operator_number_search?: string | null;
  limit?: number;
}): Promise<ProductionReportReviewBoardItem[]> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/review-board',
    {
      params: {
        review_status: params?.review_status || undefined,
        shift: params?.shift || undefined,
        production_line_config_id: params?.production_line_config_id || undefined,
        date_from: params?.date_from || undefined,
        date_to: params?.date_to || undefined,
        operator_number_search: params?.operator_number_search || undefined,
        limit: params?.limit ?? 200,
      },
    },
  );

  return data as ProductionReportReviewBoardItem[];
}

export async function getIndustrialCostProductionReportReviewBoardSummary(params?: {
  shift?: string | null;
  production_line_config_id?: string | null;
  date_from?: string | null;
  date_to?: string | null;
  operator_number_search?: string | null;
}): Promise<ProductionReportReviewBoardSummary> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/review-board-summary',
    {
      params: {
        shift: params?.shift || undefined,
        production_line_config_id: params?.production_line_config_id || undefined,
        date_from: params?.date_from || undefined,
        date_to: params?.date_to || undefined,
        operator_number_search: params?.operator_number_search || undefined,
      },
    },
  );

  return data as ProductionReportReviewBoardSummary;
}

export async function getIndustrialCostProductionReportDetail(
  reportId: string,
): Promise<ProductionReportDetail> {
  const { data } = await axiosInstance.get(
    `/industrial-costs/production-reports/${reportId}`,
  );

  return data as ProductionReportDetail;
}

export async function resolveIndustrialCostExistingProductionOrder(params: {
  manufacturing_order_number: string;
  production_line_config_id?: string | null;
}): Promise<ExistingProductionOrderLookup> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/resolve-existing-order',
    {
      params: {
        manufacturing_order_number: params.manufacturing_order_number,
        production_line_config_id: params.production_line_config_id || undefined,
      },
    },
  );

  return data as ExistingProductionOrderLookup;
}

export async function searchIndustrialCostExistingProductionOrders(params: {
  search_text: string;
  production_line_config_id?: string | null;
  limit?: number;
}): Promise<ExistingProductionOrderSearchItem[]> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/search-existing-orders',
    {
      params: {
        search_text: params.search_text,
        production_line_config_id: params.production_line_config_id || undefined,
        limit: params.limit ?? 8,
      },
    },
  );

  return data as ExistingProductionOrderSearchItem[];
}

export async function listIndustrialCostExistingProductionOrdersCandidates(params?: {
  production_line_config_id?: string | null;
}): Promise<ExistingProductionOrderCandidate[]> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/existing-orders-candidates',
    {
      params: {
        production_line_config_id: params?.production_line_config_id || undefined,
      },
    },
  );

  return data as ExistingProductionOrderCandidate[];
}

export async function getIndustrialCostProductionPlanningContext(params: {
  planned_date: string;
}): Promise<ProductionPlanningContext> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-planning/context',
    {
      params: {
        planned_date: params.planned_date,
      },
    },
  );

  return data as ProductionPlanningContext;
}

export async function getIndustrialCostProductionPlanningWeekContext(params: {
  week_start_date: string;
}): Promise<ProductionPlanningWeekContext> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-planning/week-context',
    {
      params: {
        week_start_date: params.week_start_date,
      },
    },
  );

  return data as ProductionPlanningWeekContext;
}

export async function getIndustrialCostProductionPlanningLineQueue(params: {
  production_line_config_id: string;
}): Promise<ProductionPlanItem[]> {
  const { data } = await axiosInstance.get(
    `/industrial-costs/production-planning/lines/${params.production_line_config_id}/queue`,
  );

  return data as ProductionPlanItem[];
}

export async function upsertIndustrialCostProductionPlanLineDaySettings(
  payload: UpsertProductionPlanLineDaySettingsPayload,
): Promise<ProductionPlanLineDaySettings> {
  const { data } = await axiosInstance.put(
    '/industrial-costs/production-planning/line-day-settings',
    payload,
  );

  return data as ProductionPlanLineDaySettings;
}

export async function listIndustrialCostProductionPlanItems(params: {
  planned_date: string;
}): Promise<ProductionPlanItem[]> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-planning/items',
    {
      params: {
        planned_date: params.planned_date,
      },
    },
  );

  return data as ProductionPlanItem[];
}

export async function createIndustrialCostProductionPlanItem(
  payload: CreateProductionPlanItemPayload,
): Promise<ProductionPlanItem> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/production-planning/items',
    payload,
  );

  return data as ProductionPlanItem;
}

export async function updateIndustrialCostProductionPlanItem(
  planItemId: string,
  payload: UpdateProductionPlanItemPayload,
): Promise<ProductionPlanItem> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/production-planning/items/${planItemId}`,
    payload,
  );

  return data as ProductionPlanItem;
}

export async function updateIndustrialCostProductionPlanGroupScheduleAdjustment(
  payload: ProductionPlanGroupScheduleAdjustmentPayload,
): Promise<ProductionPlanItem[]> {
  const { data } = await axiosInstance.put(
    '/industrial-costs/production-planning/groups/schedule-adjustment',
    payload,
  );

  return data as ProductionPlanItem[];
}

export async function unplanIndustrialCostProductionPlanGroup(
  payload: ProductionPlanGroupUnplanPayload,
): Promise<ProductionPlanItem[]> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/production-planning/groups/unplan',
    payload,
  );

  return data as ProductionPlanItem[];
}

export async function moveIndustrialCostProductionPlanGroupToLockedStart(
  payload: ProductionPlanGroupMoveToLockedStartPayload,
): Promise<ProductionPlanItem[]> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/production-planning/groups/move-to-locked-start',
    payload,
  );

  return data as ProductionPlanItem[];
}

export async function resolveIndustrialCostProductionPlanGroupLockedStartConflict(
  payload: ProductionPlanGroupResolveLockedStartConflictPayload,
): Promise<ProductionPlanItem[]> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/production-planning/groups/resolve-locked-start-conflict',
    payload,
  );

  return data as ProductionPlanItem[];
}

export async function deleteIndustrialCostProductionPlanItem(
  planItemId: string,
): Promise<ProductionPlanItem> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/production-planning/items/${planItemId}`,
  );

  return data as ProductionPlanItem;
}

export async function updateIndustrialCostProductionReport(
  reportId: string,
  payload: UpdateProductionReportPayload,
): Promise<ProductionReport> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/production-reports/${reportId}`,
    payload,
  );

  return data as ProductionReport;
}

export async function updateIndustrialCostProductionReportOperatorNumber(
  reportId: string,
  payload: UpdateProductionReportOperatorNumberPayload,
): Promise<ProductionReport> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/production-reports/${reportId}/operator-number`,
    payload,
  );

  return data as ProductionReport;
}

export async function validateIndustrialCostProductionReport(
  reportId: string,
): Promise<ProductionReport> {
  const { data } = await axiosInstance.post(
    `/industrial-costs/production-reports/${reportId}/validate`,
  );

  return data as ProductionReport;
}

export async function reopenIndustrialCostProductionReport(
  reportId: string,
  payload: ReopenProductionReportPayload,
): Promise<ProductionReport> {
  const { data } = await axiosInstance.post(
    `/industrial-costs/production-reports/${reportId}/reopen`,
    payload,
  );

  return data as ProductionReport;
}

export async function createIndustrialCostProductionReportLine(
  reportId: string,
  payload: CreateProductionReportLinePayload,
): Promise<ProductionReportLine> {
  const { data } = await axiosInstance.post(
    `/industrial-costs/production-reports/${reportId}/lines`,
    payload,
  );

  return data as ProductionReportLine;
}

export async function updateIndustrialCostProductionReportLine(
  reportId: string,
  lineId: string,
  payload: UpdateProductionReportLinePayload,
): Promise<ProductionReportLine> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/production-reports/${reportId}/lines/${lineId}`,
    payload,
  );

  return data as ProductionReportLine;
}

type IndustrialCostProductionReportExportParams = {
  date_from: string;
  date_to: string;
  production_line_config_id?: string | null;
  shift?: string | null;
};

async function downloadIndustrialCostProductionReportExport(
  endpoint: 'export' | 'export-stops',
  filenamePrefix: string,
  params: IndustrialCostProductionReportExportParams,
): Promise<void> {
  const { supabase } = await import('../../../config/supabaseClient');
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;

  const baseUrl = (axiosInstance.defaults.baseURL ?? '').replace(/\/$/, '');
  const queryParams = new URLSearchParams({
    date_from: params.date_from,
    date_to: params.date_to,
  });

  if (params.production_line_config_id) {
    queryParams.set(
      'production_line_config_id',
      params.production_line_config_id,
    );
  }

  if (params.shift) {
    queryParams.set('shift', params.shift);
  }

  const response = await fetch(
    `${baseUrl}/industrial-costs/production-reports/${endpoint}?${queryParams.toString()}`,
    {
      method: 'GET',
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    },
  );

  if (!response.ok) {
    throw new Error(`Error al exportar: ${response.status}`);
  }

  const blob = await response.blob();
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = objectUrl;
  link.setAttribute(
    'download',
    `${filenamePrefix}_${params.date_from}_${params.date_to}.xlsx`,
  );

  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
}

export async function exportIndustrialCostProductionReportLines(
  params: IndustrialCostProductionReportExportParams,
): Promise<void> {
  return downloadIndustrialCostProductionReportExport(
    'export',
    'ordenes_fabricacion',
    params,
  );
}

export async function exportIndustrialCostProductionReportStops(
  params: IndustrialCostProductionReportExportParams,
): Promise<void> {
  return downloadIndustrialCostProductionReportExport(
    'export-stops',
    'paradas_fabrica',
    params,
  );
}

export async function getIndustrialCostLineRecentHistory(params: {
  production_line_config_id: string;
  limit?: number;
}): Promise<ProductionReportDetail[]> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/line-recent-history',
    { params: { production_line_config_id: params.production_line_config_id, limit: params.limit ?? 3 } },
  );
  return data as ProductionReportDetail[];
}

export async function getIndustrialCostLineDefaultsSuggestion(params: {
  production_line_config_id: string;
  free_product_ref: string;
}): Promise<{ found: boolean; speed_value: number | null; extra_fields: Record<string, unknown> }> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/suggest-line-defaults',
    { params },
  );
  return data as { found: boolean; speed_value: number | null; extra_fields: Record<string, unknown> };
}

export async function deleteIndustrialCostProductionReport(
  reportId: string,
): Promise<{ status: string; deleted: boolean; report_id: string }> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/production-reports/${reportId}`,
  );
  return data as { status: string; deleted: boolean; report_id: string };
}

export async function deleteIndustrialCostProductionReportLine(
  reportId: string,
  lineId: string,
): Promise<{ status: string; deleted: boolean; line_id: string }> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/production-reports/${reportId}/lines/${lineId}`,
  );

  return data as { status: string; deleted: boolean; line_id: string };
}

export async function createIndustrialCostProductionReportStop(
  reportId: string,
  payload: CreateProductionReportStopPayload,
): Promise<ProductionReportStop> {
  const { data } = await axiosInstance.post(
    `/industrial-costs/production-reports/${reportId}/stops`,
    payload,
  );

  return data as ProductionReportStop;
}

export async function updateIndustrialCostProductionReportStop(
  reportId: string,
  stopId: string,
  payload: UpdateProductionReportStopPayload,
): Promise<ProductionReportStop> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/production-reports/${reportId}/stops/${stopId}`,
    payload,
  );

  return data as ProductionReportStop;
}

export async function deleteIndustrialCostProductionReportStop(
  reportId: string,
  stopId: string,
): Promise<{ status: string; deleted: boolean; stop_id: string }> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/production-reports/${reportId}/stops/${stopId}`,
  );

  return data as { status: string; deleted: boolean; stop_id: string };
}

export async function createIndustrialCostProductionReportIdlePeriod(
  reportId: string,
  payload: CreateProductionReportIdlePeriodPayload,
): Promise<ProductionReportIdlePeriod> {
  const { data } = await axiosInstance.post(
    `/industrial-costs/production-reports/${reportId}/idle-periods`,
    payload,
  );

  return data as ProductionReportIdlePeriod;
}

export async function updateIndustrialCostProductionReportIdlePeriod(
  reportId: string,
  idlePeriodId: string,
  payload: UpdateProductionReportIdlePeriodPayload,
): Promise<ProductionReportIdlePeriod> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/production-reports/${reportId}/idle-periods/${idlePeriodId}`,
    payload,
  );

  return data as ProductionReportIdlePeriod;
}

export async function deleteIndustrialCostProductionReportIdlePeriod(
  reportId: string,
  idlePeriodId: string,
): Promise<{ status: string; deleted: boolean; idle_period_id: string }> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/production-reports/${reportId}/idle-periods/${idlePeriodId}`,
  );

  return data as { status: string; deleted: boolean; idle_period_id: string };
}

export async function upsertIndustrialCostProductionReportQualityResult(
  reportId: string,
  payload: UpsertProductionReportQualityResultPayload,
): Promise<ProductionReportQualityResultRow> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/production-reports/${reportId}/quality-results`,
    payload,
  );

  return data as ProductionReportQualityResultRow;
}

export async function listIndustrialCostProductionLineGroupsConfig(): Promise<ProductionLineGroup[]> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/config/production-line-groups',
    {
      params: { include_inactive: true },
    },
  );

  return data as ProductionLineGroup[];
}

export async function createIndustrialCostProductionLineGroupConfig(
  payload: UpsertProductionLineGroupPayload,
): Promise<ProductionLineGroup> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/production-reports/config/production-line-groups',
    payload,
  );

  return data as ProductionLineGroup;
}

export async function updateIndustrialCostProductionLineGroupConfig(
  groupId: string,
  payload: UpsertProductionLineGroupPayload,
): Promise<ProductionLineGroup> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/production-reports/config/production-line-groups/${groupId}`,
    payload,
  );

  return data as ProductionLineGroup;
}

export async function deactivateIndustrialCostProductionLineGroupConfig(
  groupId: string,
): Promise<ProductionLineGroup> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/production-reports/config/production-line-groups/${groupId}`,
  );

  return data as ProductionLineGroup;
}

export async function listIndustrialCostProductionLinesConfig(): Promise<ProductionLineConfig[]> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/config/production-lines',
    {
      params: { include_inactive: true },
    },
  );

  return data as ProductionLineConfig[];
}

export async function createIndustrialCostProductionLineConfig(
  payload: UpsertProductionLineConfigPayload,
): Promise<ProductionLineConfig> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/production-reports/config/production-lines',
    payload,
  );

  return data as ProductionLineConfig;
}

export async function updateIndustrialCostProductionLineConfig(
  lineId: string,
  payload: UpsertProductionLineConfigPayload,
): Promise<ProductionLineConfig> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/production-reports/config/production-lines/${lineId}`,
    payload,
  );

  return data as ProductionLineConfig;
}

export async function deactivateIndustrialCostProductionLineConfig(
  lineId: string,
): Promise<ProductionLineConfig> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/production-reports/config/production-lines/${lineId}`,
  );

  return data as ProductionLineConfig;
}

export async function listIndustrialCostProductionShiftsConfig(): Promise<ProductionShiftConfig[]> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/config/shifts',
    {
      params: { include_inactive: true },
    },
  );

  return data as ProductionShiftConfig[];
}

export async function createIndustrialCostProductionShiftConfig(
  payload: UpsertProductionShiftConfigPayload,
): Promise<ProductionShiftConfig> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/production-reports/config/shifts',
    payload,
  );

  return data as ProductionShiftConfig;
}

export async function updateIndustrialCostProductionShiftConfig(
  shiftId: string,
  payload: UpsertProductionShiftConfigPayload,
): Promise<ProductionShiftConfig> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/production-reports/config/shifts/${shiftId}`,
    payload,
  );

  return data as ProductionShiftConfig;
}

export async function deactivateIndustrialCostProductionShiftConfig(
  shiftId: string,
): Promise<ProductionShiftConfig> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/production-reports/config/shifts/${shiftId}`,
  );

  return data as ProductionShiftConfig;
}

export async function listIndustrialCostProductionReportStopReasonsConfig(): Promise<ProductionReportStopReason[]> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/config/stop-reasons',
    {
      params: { include_inactive: true },
    },
  );

  return data as ProductionReportStopReason[];
}

export async function createIndustrialCostProductionReportStopReasonConfig(
  payload: UpsertProductionReportStopReasonPayload,
): Promise<ProductionReportStopReason> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/production-reports/config/stop-reasons',
    payload,
  );

  return data as ProductionReportStopReason;
}

export async function updateIndustrialCostProductionReportStopReasonConfig(
  reasonId: string,
  payload: UpsertProductionReportStopReasonPayload,
): Promise<ProductionReportStopReason> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/production-reports/config/stop-reasons/${reasonId}`,
    payload,
  );

  return data as ProductionReportStopReason;
}

export async function deactivateIndustrialCostProductionReportStopReasonConfig(
  reasonId: string,
): Promise<ProductionReportStopReason> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/production-reports/config/stop-reasons/${reasonId}`,
  );

  return data as ProductionReportStopReason;
}

export async function listIndustrialCostProductionReportQualityControlsConfig(params?: {
  template_id?: string | null;
}): Promise<ProductionReportQualityControl[]> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/config/quality-controls',
    {
      params: {
        template_id: params?.template_id || undefined,
        include_inactive: true,
      },
    },
  );

  return data as ProductionReportQualityControl[];
}

export async function createIndustrialCostProductionReportQualityControlConfig(
  payload: UpsertProductionReportQualityControlPayload,
): Promise<ProductionReportQualityControl> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/production-reports/config/quality-controls',
    payload,
  );

  return data as ProductionReportQualityControl;
}

export async function updateIndustrialCostProductionReportQualityControlConfig(
  controlId: string,
  payload: UpsertProductionReportQualityControlPayload,
): Promise<ProductionReportQualityControl> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/production-reports/config/quality-controls/${controlId}`,
    payload,
  );

  return data as ProductionReportQualityControl;
}

export async function deactivateIndustrialCostProductionReportQualityControlConfig(
  controlId: string,
): Promise<ProductionReportQualityControl> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/production-reports/config/quality-controls/${controlId}`,
  );

  return data as ProductionReportQualityControl;
}

export async function listIndustrialCostPlantUsersConfig(): Promise<PlantUser[]> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/config/plant-users',
  );

  return data as PlantUser[];
}

export async function createIndustrialCostPlantUserConfig(
  payload: CreatePlantUserPayload,
): Promise<PlantUser> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/production-reports/config/plant-users',
    payload,
  );

  return data as PlantUser;
}

export async function previewIndustrialCostImportedManufacturingOrdersImport(
  file: File,
  mapping?: Record<string, string | null>,
  productResolution?: Record<string, string>,
  normalization?: {
    sheet_name?: string | null;
    header_row_index?: number | null;
  },
  corrections?: ImportedManufacturingOrderImportCorrection[],
): Promise<ImportedManufacturingOrderImportPreviewResponse> {
  const formData = new FormData();
  formData.append('file', file);

  if (mapping) {
    formData.append('mapping_json', JSON.stringify(mapping));
  }

  if (productResolution) {
    formData.append(
      'product_resolution_json',
      JSON.stringify(productResolution),
    );
  }

  if (corrections && corrections.length > 0) {
    formData.append(
      'corrections_json',
      JSON.stringify(corrections),
    );
  }

  if (normalization?.sheet_name) {
    formData.append('sheet_name', normalization.sheet_name);
  }

  if (
    normalization?.header_row_index !== undefined &&
    normalization.header_row_index !== null
  ) {
    formData.append(
      'header_row_index',
      String(normalization.header_row_index),
    );
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/production-reports/imported-manufacturing-orders/import/preview',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as ImportedManufacturingOrderImportPreviewResponse;
}

export async function confirmIndustrialCostImportedManufacturingOrdersImport(
  file: File,
  mapping?: Record<string, string | null>,
  productResolution?: Record<string, string>,
  normalization?: {
    sheet_name?: string | null;
    header_row_index?: number | null;
  },
  corrections?: ImportedManufacturingOrderImportCorrection[],
): Promise<ImportedManufacturingOrderImportConfirmResponse> {
  const formData = new FormData();
  formData.append('file', file);

  if (mapping) {
    formData.append('mapping_json', JSON.stringify(mapping));
  }

  if (productResolution) {
    formData.append(
      'product_resolution_json',
      JSON.stringify(productResolution),
    );
  }

  if (corrections && corrections.length > 0) {
    formData.append(
      'corrections_json',
      JSON.stringify(corrections),
    );
  }

  if (normalization?.sheet_name) {
    formData.append('sheet_name', normalization.sheet_name);
  }

  if (
    normalization?.header_row_index !== undefined &&
    normalization.header_row_index !== null
  ) {
    formData.append(
      'header_row_index',
      String(normalization.header_row_index),
    );
  }

  appendFileModifiedDate(formData, file);

  const { data } = await axiosInstance.post(
    '/industrial-costs/production-reports/imported-manufacturing-orders/import/confirm',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as ImportedManufacturingOrderImportConfirmResponse;
}


// IND-004: fecha de modificación del fichero (día local) para la fecha de
// los datos de OF y compras.
function appendFileModifiedDate(formData: FormData, file: File): void {
  if (!file.lastModified) return;
  const value = new Date(file.lastModified);
  const pad = (n: number) => String(n).padStart(2, '0');
  formData.append(
    'source_file_modified_date',
    `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`,
  );
}

export async function previewIndustrialCostPurchaseOrdersImport(
  file: File,
  mapping?: Record<string, string | null>,
  normalization?: {
    sheet_name?: string | null;
    header_row_index?: number | null;
  },
): Promise<PurchaseOrderImportPreviewResponse> {
  const formData = new FormData();
  formData.append('file', file);

  if (mapping) {
    formData.append('mapping_json', JSON.stringify(mapping));
  }

  if (normalization?.sheet_name) {
    formData.append('sheet_name', normalization.sheet_name);
  }

  if (
    normalization?.header_row_index !== undefined &&
    normalization.header_row_index !== null
  ) {
    formData.append(
      'header_row_index',
      String(normalization.header_row_index),
    );
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/material-control/sources/purchase-orders/preview',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as PurchaseOrderImportPreviewResponse;
}

export async function confirmIndustrialCostPurchaseOrdersImport(
  file: File,
  mapping?: Record<string, string | null>,
  normalization?: {
    sheet_name?: string | null;
    header_row_index?: number | null;
  },
): Promise<PurchaseOrderImportConfirmResponse> {
  const formData = new FormData();
  formData.append('file', file);
  appendFileModifiedDate(formData, file);

  if (mapping) {
    formData.append('mapping_json', JSON.stringify(mapping));
  }

  if (normalization?.sheet_name) {
    formData.append('sheet_name', normalization.sheet_name);
  }

  if (
    normalization?.header_row_index !== undefined &&
    normalization.header_row_index !== null
  ) {
    formData.append(
      'header_row_index',
      String(normalization.header_row_index),
    );
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/material-control/sources/purchase-orders/confirm',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as PurchaseOrderImportConfirmResponse;
}

export async function updateIndustrialCostPlantUserConfig(
  accessId: string,
  payload: UpdatePlantUserPayload,
): Promise<PlantUser> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/production-reports/config/plant-users/${accessId}`,
    payload,
  );

  return data as PlantUser;
}

export async function deactivateIndustrialCostPlantUserConfig(
  accessId: string,
): Promise<PlantUser> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/production-reports/config/plant-users/${accessId}`,
  );

  return data as PlantUser;
}

export async function resetIndustrialCostPlantUserPasswordConfig(
  accessId: string,
  payload: ResetPlantUserPasswordPayload,
): Promise<PlantUser> {
  const { data } = await axiosInstance.post(
    `/industrial-costs/production-reports/config/plant-users/${accessId}/reset-password`,
    payload,
  );

  return data as PlantUser;
}

function normalizeProductionValidationRules(
  validationRules: Partial<ProductionOperationSettings['validation_rules']> | null | undefined,
): ProductionOperationSettings['validation_rules'] {
  const requireActualQuantityOnClose = Boolean(
    validationRules?.require_actual_quantity_on_close ??
      validationRules?.require_actual_meters_on_close ??
      false,
  );

  return {
    block_start_if_required_fields_missing:
      validationRules?.block_start_if_required_fields_missing ?? true,
    block_close_if_required_actuals_missing:
      validationRules?.block_close_if_required_actuals_missing ?? true,
    block_close_if_open_stop_exists:
      validationRules?.block_close_if_open_stop_exists ?? true,
    allow_edit_after_start: validationRules?.allow_edit_after_start ?? true,
    highlight_delay_vs_estimated:
      validationRules?.highlight_delay_vs_estimated ?? true,
    require_actual_quantity_on_close: requireActualQuantityOnClose,
    require_actual_meters_on_close: requireActualQuantityOnClose,
  };
}

function normalizeProductionEstimationConfig(
  estimationConfig: Partial<ProductionEstimationConfig> | null | undefined,
): ProductionEstimationConfig {
  const inferredMode =
    estimationConfig?.mode ??
    (estimationConfig?.enable_estimated_duration ? 'quantity_by_speed' : 'none');

  return {
    enable_estimated_duration: estimationConfig?.enable_estimated_duration ?? false,
    enable_estimated_end_time: estimationConfig?.enable_estimated_end_time ?? false,
    include_setup_time: estimationConfig?.include_setup_time ?? false,
    mode: inferredMode,
    speed_time_unit: estimationConfig?.speed_time_unit ?? 'minute',
    multiplier_field_key: estimationConfig?.multiplier_field_key ?? null,
  };
}

function normalizeProductionTraceabilityConfig(
  traceabilityConfig:
    | Partial<ProductionOperationSettings['traceability_config']>
    | null
    | undefined,
): ProductionOperationSettings['traceability_config'] {
  const mode = traceabilityConfig?.mode;

  const normalizedMode =
    mode === 'none' ||
    mode === 'basic_manual' ||
    mode === 'controlled_lots' ||
    mode === 'regulated_genealogy' ||
    mode === 'process_ai'
      ? mode
      : 'basic_manual';

  return {
    mode: normalizedMode,
    material_usage_capture_enabled:
      traceabilityConfig?.material_usage_capture_enabled ?? true,
    require_material_usage_on_line_close:
      traceabilityConfig?.require_material_usage_on_line_close ?? false,
    require_lot_on_material_usage:
      traceabilityConfig?.require_lot_on_material_usage ?? true,
    require_quantity_on_material_usage:
      traceabilityConfig?.require_quantity_on_material_usage ?? false,
    require_existing_material_lot:
      traceabilityConfig?.require_existing_material_lot ?? false,
    allow_manual_material_name:
      traceabilityConfig?.allow_manual_material_name ?? true,
    enable_run_segments:
      traceabilityConfig?.enable_run_segments ?? true,
    enable_manual_run_segments:
      traceabilityConfig?.enable_manual_run_segments ?? false,
    enable_formula_tracking:
      traceabilityConfig?.enable_formula_tracking ?? false,
    enable_output_lots:
      traceabilityConfig?.enable_output_lots ?? false,
    enable_quality_samples:
      traceabilityConfig?.enable_quality_samples ?? false,
    enable_process_variables:
      traceabilityConfig?.enable_process_variables ?? false,
    enable_vision_defects:
      traceabilityConfig?.enable_vision_defects ?? false,
    enable_recall_traceability:
      traceabilityConfig?.enable_recall_traceability ?? false,
  };
}

export async function listIndustrialCostProductionMaterialLots(
  params: {
    search?: string | null;
    include_unavailable?: boolean;
    limit?: number;
  } = {},
): Promise<ProductionMaterialLot[]> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/material-lots',
    {
      params: {
        search: params.search || undefined,
        include_unavailable: params.include_unavailable ?? false,
        limit: params.limit ?? 50,
      },
    },
  );

  return data as ProductionMaterialLot[];
}

export async function createIndustrialCostProductionMaterialLot(
  payload: CreateProductionMaterialLotPayload,
): Promise<ProductionMaterialLot> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/production-reports/material-lots',
    payload,
  );

  return data as ProductionMaterialLot;
}

export async function updateIndustrialCostProductionMaterialLot(
  materialLotId: string,
  payload: UpdateProductionMaterialLotPayload,
): Promise<ProductionMaterialLot> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/production-reports/material-lots/${materialLotId}`,
    payload,
  );

  return data as ProductionMaterialLot;
}

export async function getIndustrialCostProductionOperationSettingsConfig(): Promise<ProductionOperationSettings> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/production-reports/config/operation-settings',
  );

  return {
    ...data,
    additional_fields_config: data?.additional_fields_config ?? [],
    estimation_config: normalizeProductionEstimationConfig(data?.estimation_config),
    validation_rules: normalizeProductionValidationRules(data?.validation_rules),
    traceability_config: normalizeProductionTraceabilityConfig(data?.traceability_config),
    production_report_form_layout_config:
      data?.production_report_form_layout_config ?? null,
  } as ProductionOperationSettings;
}

export async function updateIndustrialCostProductionOperationSettingsConfig(
  payload: UpdateProductionOperationSettingsPayload,
): Promise<ProductionOperationSettings> {
  const { data } = await axiosInstance.put(
    '/industrial-costs/production-reports/config/operation-settings',
    payload,
  );

  return {
    ...data,
    additional_fields_config: data?.additional_fields_config ?? [],
    estimation_config: normalizeProductionEstimationConfig(data?.estimation_config),
    validation_rules: normalizeProductionValidationRules(data?.validation_rules),
    traceability_config: normalizeProductionTraceabilityConfig(data?.traceability_config),
    production_report_form_layout_config:
      data?.production_report_form_layout_config ?? null,
  } as ProductionOperationSettings;
}

export async function getIndustrialCostStages(): Promise<StageListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/stages');
  return data as StageListResponse;
}

export async function createIndustrialCostStage(
  payload: CreateStagePayload,
): Promise<void> {
  await axiosInstance.post('/industrial-costs/stages', payload);
}

export async function updateIndustrialCostStage(
  stageId: string,
  payload: UpdateStagePayload,
): Promise<void> {
  await axiosInstance.put(`/industrial-costs/stages/${stageId}`, payload);
}

export async function deleteIndustrialCostStage(stageId: string): Promise<void> {
  await axiosInstance.delete(`/industrial-costs/stages/${stageId}`);
}

export async function getIndustrialCostProducts(): Promise<ProductListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/products');
  return data as ProductListResponse;
}

export async function createIndustrialCostProduct(
  payload: CreateProductPayload,
): Promise<void> {
  await axiosInstance.post('/industrial-costs/products', payload);
}

export async function updateIndustrialCostProduct(
  productId: string,
  payload: UpdateProductPayload,
): Promise<void> {
  await axiosInstance.put(`/industrial-costs/products/${productId}`, payload);
}

export async function deleteIndustrialCostProduct(productId: string): Promise<void> {
  await axiosInstance.delete(`/industrial-costs/products/${productId}`);
}

export async function previewIndustrialCostProductsImport(
  file: File,
  mapping?: Record<string, string | null>,
  sheetName: string | null = null,
  headerRowIndex: number | null = null,
): Promise<ProductImportPreviewResponse> {
  const formData = new FormData();
  formData.append('file', file);

  if (mapping) {
    formData.append('mapping_json', JSON.stringify(mapping));
  }

  if (sheetName !== null) {
    formData.append('sheet_name', sheetName);
  }

  if (headerRowIndex !== null) {
    formData.append('header_row_index', String(headerRowIndex));
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/products/import/preview',
    formData,
  );

  return data as ProductImportPreviewResponse;
}

export async function confirmIndustrialCostProductsImport(
  file: File,
  mapping: Record<string, string | null>,
  sheetName: string | null = null,
  headerRowIndex: number | null = null,
): Promise<ProductImportConfirmResponse> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('mapping_json', JSON.stringify(mapping));

  if (sheetName !== null) {
    formData.append('sheet_name', sheetName);
  }

  if (headerRowIndex !== null) {
    formData.append('header_row_index', String(headerRowIndex));
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/products/import/confirm',
    formData,
  );

  return data as ProductImportConfirmResponse;
}

export type IndustrialCostDataSourceStatusItem = {
  source_key:
    | 'production'
    | 'direct-inputs'
    | 'manufacturing-orders'
    | 'purchase-orders'
    | 'inventory-count'
    | 'technical-consumptions'
    | 'box-customer-personalizations'
    | 'box-purchase-mappings';
  status: 'published' | 'data_available' | 'not_found';
  evidence_kind:
    | 'published_snapshot'
    | 'business_rows'
    | 'none';
  effective_at: string | null;
  data_date: string | null;
  source_file_name: string | null;
  rows_count: number | null;
};

export async function getIndustrialCostDataSourceStatus(): Promise<
  IndustrialCostDataSourceStatusItem[]
> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/data-source-status',
  );

  return data as IndustrialCostDataSourceStatusItem[];
}

// IND-002: resultado de la carga diaria (se ve tras recargar la página).
// IND-004: qué se descartó del fichero y por qué (resumen).
export type DailyLoadRunDiscard = {
  code: string;
  label: string;
  count: number;
  examples: string[];
  // IND-017: nivel del aviso (Informativo / Cifra incompleta).
  level?: 'blocks' | 'incomplete' | 'info' | null;
};

export type DataDateKind = 'count' | 'production' | 'file_modified' | 'erp_extraction' | 'load';

export type DailyLoadRunFile = {
  source_key: string;
  file_name: string;
  status: 'updated' | 'unchanged' | 'warning' | 'error' | 'not_loaded';
  label: string;
  summary: string | null;
  data_date?: string | null;
  data_date_kind?: DataDateKind | null;
  discards?: DailyLoadRunDiscard[];
  // IND-019: recuentos y fechas de la línea de resumen de la tarjeta.
  result?: DailyLoadRunResult | null;
};

export type DailyLoadRunResult = {
  rows?: number | null;
  existing?: number | null;
  replaced?: number | null;
  date_from?: string | null;
  date_to?: string | null;
};

export type DailyLoadRun = {
  id: string;
  created_at: string;
  overall_status: 'ok' | 'warning' | 'incomplete' | 'error';
  files: DailyLoadRunFile[];
};

export async function saveDailyLoadRun(files: DailyLoadRunFile[]): Promise<DailyLoadRun> {
  const { data } = await axiosInstance.post('/industrial-costs/daily-load-runs', { files });
  return data as DailyLoadRun;
}

export async function getLatestDailyLoadRun(): Promise<DailyLoadRun | null> {
  const { data } = await axiosInstance.get('/industrial-costs/daily-load-runs/latest');
  return (data as DailyLoadRun | null) ?? null;
}

// IND-004: «Datos a fecha» y avisos de desfase del Panel.
export type PlantDataFreshnessItem = {
  source_key: 'inventory-counts' | 'production' | 'direct-inputs' | 'manufacturing-orders' | 'purchase-orders';
  label: string;
  data_date: string | null;
  data_date_kind: DataDateKind | null;
  data_date_kind_label: string | null;
  source_file_name?: string | null;
  covered_from?: string | null;
  days_with_production?: number;
  last_entry_date?: string | null;
};

export type PlantDataFreshnessWarning = {
  code: string;
  severity: 'warning' | 'info';
  source_key: string;
  message: string;
  dates?: string[];
};

export type PlantDataFreshness = {
  items: PlantDataFreshnessItem[];
  warnings: PlantDataFreshnessWarning[];
};

// IND-023: diferencia de inventario (stock calculado frente a recuento).
export type InventoryDifferenceDate = {
  count_date: string;
  has_snapshot: boolean;
  kind: 'on_load' | 'retroactive' | null;
  can_compute: boolean;
};

export type InventoryDifferenceConsumer = {
  product_id: string;
  product_code: string | null;
  product_name: string | null;
  customer_number: string | null;
  basis_unit: string | null;
  produced_qty: number | null;
  consumed_qty: number | null;
  consumption_per_unit: number | null;
  multiple_rules: boolean;
};

export type InventoryDifferenceRow = {
  material_id: string;
  material_code: string | null;
  material_name: string | null;
  unit_label: string | null;
  calculated_qty: number | null;
  counted_qty?: number;
  difference_qty?: number;
  difference_pct?: number | null;
  difference_consumption_pct?: number | null;
  anomaly?: boolean;
  entries_qty?: number;
  returns_qty?: number;
  consumed_qty?: number;
  baseline_qty?: number | null;
  baseline_date?: string | null;
  baseline_assumed_zero?: boolean;
  partial_consumption?: boolean;
  breakdown?: InventoryDifferenceConsumer[];
  evolution?: Array<{ count_date: string; difference_pct: number }>;
  reason?: 'sin_base' | 'nuevo' | 'parcial';
};

export type InventoryDifference = {
  snapshot: {
    count_date: string;
    base_date: string | null;
    period_from: string | null;
    period_to: string | null;
    kind: 'on_load' | 'retroactive';
    created_at: string;
    last_production_date: string | null;
    last_entry_date: string | null;
    warnings: string[];
    data_changed: boolean;
  };
  gaps: { has_gaps: boolean; workdays_without_production: string[]; production_until: string | null };
  rows: InventoryDifferenceRow[];
  not_counted: InventoryDifferenceRow[];
  without_stock: InventoryDifferenceRow[];
};

export async function listInventoryDifferenceDates(): Promise<InventoryDifferenceDate[]> {
  const { data } = await axiosInstance.get('/industrial-costs/inventory-counts/differences');
  return ((data as { dates?: InventoryDifferenceDate[] })?.dates ?? []);
}

export async function getInventoryDifference(countDate: string): Promise<InventoryDifference> {
  const { data } = await axiosInstance.get(
    `/industrial-costs/inventory-counts/differences/${encodeURIComponent(countDate)}`,
  );
  return data as InventoryDifference;
}

export async function computeInventoryDifference(countDate: string, redo = false): Promise<void> {
  await axiosInstance.post(
    `/industrial-costs/inventory-counts/differences/${encodeURIComponent(countDate)}/compute`,
    { redo },
  );
}

// IND-022: festivos de planta (solo quitan el aviso de día sin producción).
export type PlantHoliday = {
  id: string;
  holiday_date: string;
  name: string | null;
  created_by: string | null;
  created_by_label: string | null;
  created_at: string;
};

export async function listPlantHolidays(year: number): Promise<PlantHoliday[]> {
  const { data } = await axiosInstance.get('/industrial-costs/plant-data-review/holidays', { params: { year } });
  return ((data as { holidays?: PlantHoliday[] })?.holidays ?? []);
}

export async function markPlantHoliday(body: { holiday_date: string; name?: string | null }): Promise<PlantHoliday> {
  const { data } = await axiosInstance.post('/industrial-costs/plant-data-review/holidays', body);
  return data as PlantHoliday;
}

export async function unmarkPlantHoliday(holidayDate: string): Promise<void> {
  await axiosInstance.delete(`/industrial-costs/plant-data-review/holidays/${encodeURIComponent(holidayDate)}`);
}

// IND-022: «Producción por mes» de Datos de planta.
export type ProductionMonthUpload = {
  file_name: string | null;
  uploaded_at: string | null;
  date_from: string | null;
  date_to: string | null;
};

export type ProductionMonthTotals = {
  meters: number | null;
  kg: number | null;
  rows_unconverted: number;
  parts: number | null;
  days_with_production: number | null;
  workdays_without_production: number | null;
  holidays: number | null;
  manual_rows: number | null;
  monthly_rows: number | null;
};

export type ProductionMonthRow = ProductionMonthTotals & {
  month: number;
  last_upload: ProductionMonthUpload | null;
};

export type ProductionByMonth = {
  year: number;
  granularity: 'day' | 'month' | 'year' | null;
  window: { from: string; to: string | null };
  months: ProductionMonthRow[];
  total: ProductionMonthTotals;
};

export async function getProductionByMonth(year: number): Promise<ProductionByMonth> {
  const { data } = await axiosInstance.get('/industrial-costs/plant-data-review/production-by-month', {
    params: { year },
  });
  return data as ProductionByMonth;
}

export async function getPlantDataFreshness(): Promise<PlantDataFreshness> {
  const { data } = await axiosInstance.get('/industrial-costs/plant-data-freshness');
  return data as PlantDataFreshness;
}

// IC-STOCK-10: análisis del libro de recuento mensual.
// IND-018: tabla de una hoja con su cabecera y cuántos materiales trae.
export type RecountWorkbookTable = {
  kind: 'raw_materials' | 'packaging' | 'single' | 'other';
  code_header: string;
  quantity_header: string | null;
  materials_count: number;
};

// IND-018: materiales por tipo (cada código una vez) y tablas de las que salen.
export type RecountWorkbookFamily = {
  kind: 'raw_materials' | 'packaging' | 'other';
  materials_count: number;
  headers: string[];
  by_table?: Array<{ header: string; materials_count: number }>;
  sample_codes: string[];
};

export type RecountWorkbookSheet = {
  sheet_name: string;
  month: number;
  year: number | null;
  count_date: string | null;
  // IND-018
  tables?: RecountWorkbookTable[];
  families?: RecountWorkbookFamily[];
  year_source?: 'column_dates' | 'filename' | null;
  year_missing?: boolean;
  actual_changed_count?: number;
  compared_materials?: number;
  not_filled_reason?: string | null;
  header_row_index: number | null;
  tables_count: number;
  materials_count: number;
  actual_total: number;
  actual_filled: boolean;
  column_dates: { anterior: string | null; actual: string | null };
  next_sheet_name: string | null;
  next_month_check: {
    compared_materials: number;
    mismatches_count: number;
    mismatches: Array<{
      material_code: string;
      actual: number | null;
      next_month_previous: number | null;
    }>;
  } | null;
};

export type RecountWorkbookAnalysis = {
  filename: string;
  sheets: RecountWorkbookSheet[];
  ignored_sheets: string[];
  undated_sheets: string[];
  proposed_sheet_name: string | null;
  proposed_count_date: string | null;
  rule: string;
  // IND-018
  discarded_newer_sheets?: Array<{ sheet_name: string; reason: string }>;
  warnings?: Array<{ code: string; sheet_name: string; message: string }>;
};

export async function analyzeRecountWorkbook(file: File): Promise<RecountWorkbookAnalysis> {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await axiosInstance.post(
    '/industrial-costs/inventory-counts/workbook/analyze',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return data as RecountWorkbookAnalysis;
}

// IC-STOCK-09: informe "Revisa tus ficheros".
export type PlantDataReviewExample = {
  excel_row: number | null;
  reference: string;
  detail: string | null;
};

export type PlantDataReviewGroup = {
  code: string;
  severity: 'error' | 'warning';
  title: string;
  explanation: string;
  count: number;
  examples: PlantDataReviewExample[];
};

export type PlantDataReviewFile = {
  file_key: string;
  label: string;
  file_name: string;
  status: 'ok' | 'warning' | 'error';
  errors_count: number;
  warnings_count: number;
  groups: PlantDataReviewGroup[];
  // IND-012: avisos que se corrigen en este fichero y avisos que le afectan.
  notice_ids?: string[];
  related_notice_ids?: string[];
};

// IND-012: aviso con el formato de «qué falta, por qué y qué hacer».
export type PlantDataNoticeLevel = 'blocks' | 'incomplete' | 'info';

export type PlantDataNoticeAffected = {
  document_type: string;
  reference: string;
  quantity: number | null;
  unit: string | null;
  date: string | null;
  excel_row: number | null;
  source_file: string | null;
  detail: string | null;
};

export type PlantDataNotice = {
  id: string;
  code: string;
  level: PlantDataNoticeLevel;
  level_label: string;
  file_key: string;
  file_name: string | null;
  subject: { kind: string; key: string; label: string };
  title: string;
  missing_link: string;
  action: string;
  related_files: string[];
  affected_count: number;
  affected: PlantDataNoticeAffected[];
  // IND-020: cliente nuevo (arriba y marcado) y fila a añadir en el Excel.
  is_new?: boolean;
  fill_row?: Record<string, unknown> | null;
  fill_rows?: Array<Record<string, unknown>>;
  // IND-021: lo afectado en total, sobre la lista completa.
  affected_summary?: PlantDataNoticeAffectedSummary[];
};

export type PlantDataNoticeAffectedSummary = {
  document_type: string;
  count: number;
  quantity: number | null;
  unit: string | null;
};

// IND-021: qué pasa y qué hacer, comunes a un tipo de aviso.
export type PlantDataNoticeTypeTexts = { what: string; todo: string };

export type PlantDataReviewResponse = {
  generated_at: string;
  errors_count: number;
  warnings_count: number;
  files: PlantDataReviewFile[];
  notices?: PlantDataNotice[];
  counts?: Record<PlantDataNoticeLevel, number>;
  notice_types?: Record<string, PlantDataNoticeTypeTexts>;
};

export async function downloadPlantDataNoticeCsv(noticeId: string): Promise<Blob> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/plant-data-review/notices/affected.csv',
    { params: { notice_id: noticeId }, responseType: 'blob' },
  );
  return data as Blob;
}

// IND-020: «Descargar lo que falta» de una tabla maestra.
export type MissingDataTable = 'personalizaciones' | 'cajas-reales' | 'escandallo' | 'recuento';

export async function downloadMissingDataWorkbook(table: MissingDataTable): Promise<Blob> {
  const { data } = await axiosInstance.get(
    `/industrial-costs/plant-data-review/missing/${table}.xlsx`,
    { responseType: 'blob' },
  );
  return data as Blob;
}

// IND-020: productos que consumen un material desde el recuento.
export type MaterialConsumptionConsumer = {
  product_id: string;
  product_code: string | null;
  product_name: string | null;
  customer_number: string | null;
  basis: string;
  basis_unit: 'm' | 'kg';
  produced_qty: number;
  consumed_qty: number;
  consumption_per_unit: number | null;
  multiple_rules: boolean;
  rule_unit_label: string | null;
  unit_mismatch: boolean;
};

export type MaterialConsumptionBreakdown = {
  material_id: string;
  material_code: string | null;
  material_name: string | null;
  unit_label: string | null;
  baseline_count_date: string | null;
  calculated_stock_qty: number | null;
  stock_explanation_case: string | null;
  stock_consumption_ratio: number | null;
  stock_explanation: string | null;
  consumers: MaterialConsumptionConsumer[];
};

export async function getMaterialConsumptionBreakdown(materialId: string): Promise<MaterialConsumptionBreakdown> {
  const { data } = await axiosInstance.get(
    `/industrial-costs/material-stock-projection/materials/${encodeURIComponent(materialId)}/consumption`,
  );
  return data as MaterialConsumptionBreakdown;
}

// IND-024: detalle del material (histórico de consumo, ritmo y entradas).
export type MaterialConsumptionRate = {
  from: string;
  to: string;
  workdays: number;
  consumed: number | null;
  per_workday: number | null;
};

export type MaterialDetailConsumerLine = {
  product_id: string;
  product_code: string | null;
  product_name: string | null;
  line_id: string | null;
  line_name: string | null;
  basis: string;
  produced_qty: number;
  consumed_qty: number;
  consumption_per_unit: number | null;
};

export type MaterialDetail = {
  material_id: string;
  calculation_date: string;
  history_from: string | null;
  products_count: number;
  lines_count: number;
  rhythm: MaterialConsumptionRate;
  // IND-027: semanas del ritmo habitual (8 si no se han ajustado).
  rhythm_weeks: number;
  year_rate: MaterialConsumptionRate;
  recent_rate: MaterialConsumptionRate;
  recent_variation_pct: number | null;
  monthly: {
    month: string;
    consumed_qty: number | null;
    previous_year_qty: number | null;
    in_progress: boolean;
    partial: boolean;
  }[];
  year_to_date: {
    until: string;
    current_qty: number | null;
    previous_qty: number | null;
    variation_pct: number | null;
  };
  consumers_recent: {
    total_qty: number;
    products: {
      product_id: string;
      product_code: string | null;
      product_name: string | null;
      consumed_qty: number;
      pct: number | null;
    }[];
    others: { count: number; consumed_qty: number; pct: number | null } | null;
    lines: { line_id: string | null; line_name: string | null; consumed_qty: number; pct: number | null }[];
  };
  consumers_year: MaterialDetailConsumerLine[];
  entries: {
    last_3m_qty: number;
    // Decisión 29/10: inicio del periodo comparado (el de la rotación).
    period_from: string;
    consumed_3m_qty: number | null;
    entries_vs_consumption: number | null;
    // IND-026: supplier es el código del albarán; supplier_name, su nombre
    // según el propio albarán o, si falta, los pedidos de compra (null si
    // no aparece en ninguno).
    recent: {
      entry_date: string;
      quantity: number;
      supplier: string | null;
      supplier_name: string | null;
      document_ref: string | null;
    }[];
  };
  upcoming_holidays: string[];
  notes: {
    undated_production_rows: number;
    boxes_resolved_with_today_personalization: boolean;
  };
  unit_label: string | null;
  history_build_ms: number;
  from_cache: boolean;
  // IND-025
  rotation: { recent: MaterialRotationPeriod; previous: MaterialRotationPeriod };
  abc: {
    class: 'A' | 'B' | 'C' | null;
    group: string;
    group_label: string;
    share_pct: number | null;
    consumed_qty: number;
  } | null;
  regularity: {
    weeks: number;
    cv: number | null;
    label: 'regular' | 'irregular' | 'few_data' | 'no_consumption';
  };
  counts: {
    comparisons: MaterialCountComparison[];
    // IND-027: mean_pct es el sesgo (con signo, ajusta el stock) y
    // mean_abs_pct la desviación (valor absoluto, da el nivel).
    reliability: {
      mean_pct: number;
      mean_abs_pct: number;
      level: 'alta' | 'media' | 'baja';
      count_dates: string[];
    } | null;
  };
  highlights: {
    consumption_change: {
      pct: number;
      product: {
        product_id: string;
        product_code: string | null;
        product_name: string | null;
        share_of_change_pct: number;
        is_new: boolean;
      } | null;
    } | null;
    rotation_change: { pct: number; recent_days: number; previous_days: number } | null;
    idle: { last_consumption_date: string | null } | null;
    counts_bias: { direction: 'more' | 'less'; pcts: number[]; count_dates: string[] } | null;
    entries_ratio: { ratio: number; direction: 'low' | 'high' } | null;
  };
};

export type MaterialRotationPeriod = {
  from: string;
  to: string;
  // IND-028: primer día con recuento base; partial si es posterior a «from»
  // (la cifra es «desde dd/mm», con al menos 4 semanas).
  effective_from: string | null;
  partial: boolean;
  // Cambio IND-028: primer día con albaranes si es posterior al inicio, y
  // primer y último día con stock negativo del periodo efectivo.
  entries_from: string | null;
  negative_from: string | null;
  negative_to: string | null;
  // Decisión 29/10: días que faltan para el mínimo de 4 semanas.
  missing_days: number | null;
  per_workday: number | null;
  average_stock: number | null;
  negative_days_pct: number | null;
  rotation_days: number | null;
  times_per_year: number | null;
  computed_from: string | null;
  too_many_negative: boolean;
};

export type MaterialCountComparison = {
  count_date: string;
  calculated_qty: number | null;
  counted_qty: number | null;
  difference_qty: number | null;
  difference_pct: number | null;
  status: 'compared' | 'calculated_le_zero' | 'not_counted' | 'no_base';
};

// IND-026: a los 30 s se corta la espera y el detalle ofrece «Reintentar»
// (el cálculo sigue en el servidor y el reintento usa su resultado).
export const MATERIAL_DETAIL_TIMEOUT_MS = 30_000;

export async function getMaterialDetail(materialId: string): Promise<MaterialDetail> {
  const { data } = await axiosInstance.get(
    `/industrial-costs/material-stock-projection/materials/${encodeURIComponent(materialId)}/detail`,
    { timeout: MATERIAL_DETAIL_TIMEOUT_MS },
  );
  return data as MaterialDetail;
}

// IND-027: «Rotación de materiales» del Panel (todos los materiales).
export type MaterialRotationThresholds = {
  idle_weeks: number;
  slow_rotation_days: number;
  short_coverage_days: number;
  rhythm_weeks: number;
  abc_a_pct: number;
  abc_b_pct: number;
};

export type MaterialRotationThresholdsState = {
  saved: MaterialRotationThresholds | null;
  updated_at: string | null;
  updated_by_label: string | null;
};

export type MaterialRotationRow = {
  material_id: string;
  material_code: string | null;
  material_name: string | null;
  unit_label: string | null;
  material_type: string | null;
  // IND-029: unidad vacía o «nan» (materia prima: cuenta como kg).
  unit_missing: boolean;
  group: string | null;
  group_label: string | null;
  abc_class: 'A' | 'B' | 'C' | null;
  consumed_12m_qty: number;
  share_pct: number | null;
  per_workday: number | null;
  rotation_days: number | null;
  rotation_too_many_negative: boolean;
  rotation_computed_from: string | null;
  rotation_from: string | null;
  rotation_negative_days_pct: number | null;
  rotation_has_base: boolean;
  rotation_negative_from: string | null;
  rotation_negative_to: string | null;
  rotation_entries_from: string | null;
  rotation_missing_days: number | null;
  recent_variation_pct: number | null;
  last_consumption_date: string | null;
  // Consumo de las 26 últimas semanas (de la más antigua a la más reciente).
  weekly_consumed: number[];
};

export type MaterialRotationSummary = {
  calculation_date: string;
  history_from: string | null;
  rhythm_weeks: number;
  abc_a_pct: number;
  abc_b_pct: number;
  week_workdays: number[];
  consumption_gap_p90_days: number | null;
  // IND-031: desde cuándo están completas las entradas (solo lectura).
  entries_complete: {
    date: string | null;
    run_at: string | null;
    source: 'saved' | 'daily_load' | 'first_entry' | null;
    // La primera carga traía líneas ya presentes: la fecha puede ser posterior.
    partial: boolean;
    updated_at?: string | null;
    updated_by_label?: string | null;
  };
  rows: MaterialRotationRow[];
  thresholds: MaterialRotationThresholdsState;
  from_cache: boolean;
};

export async function getMaterialRotationSummary(): Promise<MaterialRotationSummary> {
  const { data } = await axiosInstance.get('/industrial-costs/material-stock-projection/rotation', {
    timeout: MATERIAL_DETAIL_TIMEOUT_MS,
  });
  return data as MaterialRotationSummary;
}

export async function saveMaterialRotationThresholds(
  thresholds: MaterialRotationThresholds & { entries_complete_from?: string | null },
): Promise<MaterialRotationThresholdsState> {
  const { data } = await axiosInstance.put(
    '/industrial-costs/material-stock-projection/rotation-thresholds',
    thresholds,
  );
  return data as MaterialRotationThresholdsState;
}

// IND-032: desperdicio mensual por grupo.
export type WasteControlGroupRow = {
  group: string;
  label: string;
  consumption_kg: number | null;
  waste_kg: number | null;
  pct: number | null;
  waste_source: 'excel' | 'proa' | null;
  // IND-033: 0 supuesto de un mes importado, no un dato registrado.
  waste_assumed?: boolean;
  // IND-034: precio ponderado del grupo en el mes y € de desperdicio.
  price_eur_kg: number | null;
  price_partial: boolean;
  waste_eur: number | null;
  updated_at: string | null;
  updated_by_label?: string | null;
};

export type WasteControlMaterialLine = {
  material_id: string;
  material_code: string | null;
  material_name: string | null;
  supplier: string | null;
  consumption_kg: number;
  share: number;
  counted_kg: number;
};

export type WasteControlMonth = {
  month: number;
  origin: 'excel' | 'proa' | null;
  has_consumption: boolean;
  missing_waste: string[];
  groups: WasteControlGroupRow[];
  materials: Record<string, WasteControlMaterialLine[]>;
  warnings: { type: string; material_code: string | null }[];
};

export type WasteControlView = {
  year: number;
  groups: { group: string; label: string }[];
  waste_groups: string[];
  months: WasteControlMonth[];
  averages: Record<string, number | null>;
  default_month: number | null;
  // IND-033: último mes con % de Desperdicio y mes anterior al actual sin cerrar.
  closed_month: number | null;
  pending: { month: number; missing_book: boolean; missing_kg: boolean } | null;
  // IND-034: bloque del año; no cambia la media del Excel.
  year_totals: {
    waste_kg: number;
    waste_eur: number;
    consumption_kg: number;
    pct: number | null;
    price_partial: boolean;
  };
};

// IND-034: coste por 100 m de producto.
export type WasteCostProduct = {
  product_id: string;
  metres: number;
  weight_kg: number;
  waste_kg: number | null;
  waste_eur: number | null;
};

export type WasteCostGroup = {
  group: string;
  metres: number;
  waste_kg: number | null;
  waste_eur: number | null;
  price_partial: boolean;
  products: WasteCostProduct[];
};

export type WasteCostExclusionReason = 'no_rules' | 'no_weight' | 'no_destination';
export type WasteCostMaterialGap = 'catalog' | 'inactive' | 'destination';

export type WasteCostView = {
  year: number;
  groups: { group: string; label: string }[];
  months: {
    month: number;
    groups: WasteCostGroup[];
    // IND-036: qué queda fuera del reparto en el mes y por qué.
    total_metres: number;
    excluded: { product_id: string; metres: number; reason: WasteCostExclusionReason }[];
    missing_materials: { material_code: string; kind: WasteCostMaterialGap; product_ids: string[] }[];
  }[];
  products: Record<string, { code: string | null; name: string | null }>;
  // IND-035: meses sin hoja STP-MP: destino del recuento más cercano.
  destination_fallback_months: number[];
};

// IND-038: EPDM por línea. El total de EPDM manda: las líneas solo se comparan.
export type WasteEpdmLinesMonth = {
  month: number;
  status: 'ok' | 'mismatch' | 'empty';
  lines_kg: number | null;
  total_kg: number | null;
  difference_kg: number | null;
  values: Record<string, number | null>;
  metres: Record<string, number>;
  missing: string[];
};

export type WasteEpdmLinesWarning =
  | {
      kind: 'mismatch';
      month: number;
      missing: string[];
      lines_kg: number;
      total_kg: number | null;
      difference_kg: number | null;
    }
  | { kind: 'unknown_line'; name: string };

export type WasteEpdmLinesView = {
  year: number;
  lines: { key: string; name: string; recognized: boolean }[];
  months: WasteEpdmLinesMonth[];
  warnings: WasteEpdmLinesWarning[];
};

// IND-046: proveedores de la Hoja de recuento: solo hace falta su código del ERP.
export type RecountSupplierNote = 'chosen' | 'book' | 'several' | 'hand' | 'no_code';

export type RecountSupplier = {
  key: string;
  name: string;
  rows: number;
  codes: string[];
  code: string | null;
  note: RecountSupplierNote;
  has_deliveries: boolean;
};

export type RecountSuppliersView = {
  sheet: { year: number; month: number } | null;
  suppliers: RecountSupplier[];
  total: number;
  with_code: number;
};

export async function getRecountSuppliers(): Promise<RecountSuppliersView> {
  const { data } = await axiosInstance.get('/industrial-costs/recount-sheets/supplier-codes', {
    timeout: MATERIAL_DETAIL_TIMEOUT_MS,
  });
  return data as RecountSuppliersView;
}

export async function saveRecountSupplierCode(supplier: string, code: string | null): Promise<void> {
  await axiosInstance.put('/industrial-costs/recount-sheets/supplier-codes', { supplier, code }, {
    timeout: MATERIAL_DETAIL_TIMEOUT_MS,
  });
}

// IND-041 a IND-043: Hoja de recuento (en pruebas, aislada).
export type RecountRowSource = 'libro' | 'tecleado' | 'copiado' | 'sugerencia';

export type RecountSheetRow = {
  id: string;
  position: number;
  destination: string | null;
  supplier: string | null;
  supplier_code: string | null;
  material_code: string;
  reference: string | null;
  class_label: string | null;
  unit: 'kg' | 'unidades';
  share: number | null;
  previous_qty: number | null;
  current_qty: number | null;
  price: number | null;
  purchases_qty: number | null;
  origins: Record<string, { source: RecountRowSource; by: string | null; at: string | null }>;
  added_by_hand: boolean;
  delivery_key: string | null;
  // IND-046: tabla del libro; vacío = materias primas.
  table_kind: 'raw_materials' | 'packaging' | 'single' | null;
  supplier_key: string;
  supplier_state: 'coded' | 'no_code';
  invalid_code: boolean;
  purchases_suggested: number | null;
  price_suggested: number | null;
};

export type RecountMissingMaterial = {
  material_code: string;
  key_code: string;
  delivery_key: string;
  delivery_name: string;
  quantity: number;
  reference: string | null;
  supplier: string | null;
  supplier_code: string | null;
};

export type RecountSheetView = {
  sheet: {
    id: string;
    year: number;
    month: number;
    sheet_name: string;
    previous_date: string;
    current_date_value: string;
    columns: string[];
  } | null;
  rows: RecountSheetRow[];
  missing: RecountMissingMaterial[];
  has_previous: boolean;
};

export type RecountEstimate = {
  state: 'ok' | 'several' | 'no_code' | 'none';
  estimate: number | null;
  material_total: number | null;
  entries: number | null;
  consumption: number;
};

export type RecountRowDetail = {
  lines: { date: string; document: string | null; quantity: number; price: number | null }[];
  total: number;
  last_price: number | null;
  last_price_date: string | null;
  supplier_code: string | null;
  previous_prices: { year: number; month: number; price: number | null }[];
};

export type RecountCompareResult = {
  equal: number;
  different: number;
  only_book: number;
  only_proa: number;
  rows: {
    kind: 'different' | 'only_book' | 'only_proa';
    material_code: string;
    supplier: string | null;
    differences: { field: string; proa: number | null; book: number | null }[];
  }[];
};

export type RecountRowDraft = {
  material_code: string;
  reference: string | null;
  supplier: string | null;
  supplier_code: string | null;
  class_label: string | null;
  destination: string | null;
  unit: 'kg' | 'unidades';
  share: number | null;
  price: number | null;
  after_row_id?: string | null;
  delivery_key?: string | null;
};

const RECOUNT_SHEETS = '/industrial-costs/recount-sheets';

export async function getRecountSheet(year: number, month: number): Promise<RecountSheetView> {
  const { data } = await axiosInstance.get(`${RECOUNT_SHEETS}/${year}/${month}`, { timeout: MATERIAL_DETAIL_TIMEOUT_MS });
  return data as RecountSheetView;
}

export async function getRecountEstimates(year: number, month: number): Promise<Record<string, RecountEstimate>> {
  const { data } = await axiosInstance.get(`${RECOUNT_SHEETS}/${year}/${month}/estimates`, { timeout: 120_000 });
  return data.estimates;
}

export async function prepareRecountSheetFromBook(
  year: number,
  month: number,
  file: File,
  sheetName: string,
  replace: boolean,
): Promise<void> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('sheet_name', sheetName);
  formData.append('replace', String(replace));
  await axiosInstance.post(`${RECOUNT_SHEETS}/${year}/${month}/prepare-book`, formData, { timeout: 120_000 });
}

export async function prepareRecountSheetFromPrevious(year: number, month: number): Promise<void> {
  await axiosInstance.post(`${RECOUNT_SHEETS}/${year}/${month}/prepare-previous`);
}

export async function saveRecountCell(
  rowId: string,
  field: string,
  value: number | string | null,
  source: RecountRowSource = 'tecleado',
  writtenAt?: string,
  device?: string,
): Promise<RecountSheetRow> {
  // IND-053: con writtenAt, PROA no pisa un valor guardado después desde otra
  // pantalla (409); device identifica a la tablet que escribe.
  const body = writtenAt
    ? { field, value, source, written_at: writtenAt, sent_at: new Date().toISOString(), device }
    : { field, value, source };
  const { data } = await axiosInstance.patch(`${RECOUNT_SHEETS}/rows/${rowId}`, body, {
    timeout: 15_000,
  });
  return data as RecountSheetRow;
}

export async function getRecountRowDetail(rowId: string): Promise<RecountRowDetail> {
  const { data } = await axiosInstance.get(`${RECOUNT_SHEETS}/rows/${rowId}/detail`, { timeout: MATERIAL_DETAIL_TIMEOUT_MS });
  return data as RecountRowDetail;
}

export async function addRecountRow(year: number, month: number, draft: RecountRowDraft): Promise<void> {
  await axiosInstance.post(`${RECOUNT_SHEETS}/${year}/${month}/rows`, draft);
}

export async function deleteRecountRow(rowId: string): Promise<void> {
  await axiosInstance.delete(`${RECOUNT_SHEETS}/rows/${rowId}`);
}

export async function applyRecountSuggestions(
  year: number,
  month: number,
  field: 'purchases_qty' | 'price',
): Promise<{ changed: number }> {
  const { data } = await axiosInstance.post(`${RECOUNT_SHEETS}/${year}/${month}/use-suggestions`, { field }, {
    timeout: 120_000,
  });
  return data;
}

export async function exportRecountSheet(year: number, month: number): Promise<Blob> {
  const { data } = await axiosInstance.get(`${RECOUNT_SHEETS}/${year}/${month}/export`, { responseType: 'blob' });
  return data as Blob;
}

export async function dismissRecountMaterial(
  year: number,
  month: number,
  materialCode: string,
  deliveryKey: string,
): Promise<void> {
  await axiosInstance.post(`${RECOUNT_SHEETS}/${year}/${month}/dismiss`, {
    material_code: materialCode,
    delivery_key: deliveryKey,
  });
}

export async function compareRecountSheet(
  year: number,
  month: number,
  file: File,
  sheetName: string,
): Promise<RecountCompareResult> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('sheet_name', sheetName);
  const { data } = await axiosInstance.post(`${RECOUNT_SHEETS}/${year}/${month}/compare`, formData, { timeout: 120_000 });
  return data as RecountCompareResult;
}

export async function getWasteEpdmLines(year: number): Promise<WasteEpdmLinesView> {
  const { data } = await axiosInstance.get('/industrial-costs/waste-control/epdm-lines', {
    params: { year },
    timeout: MATERIAL_DETAIL_TIMEOUT_MS,
  });
  return data as WasteEpdmLinesView;
}

export async function getWasteControl(year: number): Promise<WasteControlView> {
  const { data } = await axiosInstance.get('/industrial-costs/waste-control', {
    params: { year },
    timeout: MATERIAL_DETAIL_TIMEOUT_MS,
  });
  return data as WasteControlView;
}

export async function saveWasteMonth(
  year: number,
  month: number,
  values: Record<string, number | null>,
  lines?: Record<string, number | null>,
): Promise<void> {
  await axiosInstance.put(`/industrial-costs/waste-control/${year}/${month}`, lines ? { ...values, lines } : values);
}

export async function getWasteCost(year: number): Promise<WasteCostView> {
  const { data } = await axiosInstance.get('/industrial-costs/waste-control/cost-per-100m', {
    params: { year },
    timeout: MATERIAL_DETAIL_TIMEOUT_MS,
  });
  return data as WasteCostView;
}

export async function importWasteHistory(
  file: File,
): Promise<{ year: number; imported_months: number[]; skipped_months: number[]; months_without_prices: number[] }> {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await axiosInstance.post('/industrial-costs/waste-control/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data as { year: number; imported_months: number[]; skipped_months: number[]; months_without_prices: number[] };
}

// IND-011: recuento vigente («Punto de partida» de Gestión de datos).
export type RecountStatus = {
  count_date: string | null;
  materials_count: number;
  materials_with_older_count: number;
  source_file_name: string | null;
  sheet_name: string | null;
  quantity_column: string | null;
  loaded_at: string | null;
  // IND-018: desglose de la última carga.
  breakdown?: { raw_materials?: number; packaging?: number; other?: number } | null;
};

export async function getRecountStatus(): Promise<RecountStatus> {
  const { data } = await axiosInstance.get('/industrial-costs/recount-status');
  return data as RecountStatus;
}

export async function getPlantDataReview(): Promise<PlantDataReviewResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/plant-data-review');
  return data as PlantDataReviewResponse;
}

// IC-STOCK-05: maestros de cajas cargados desde Excel.
export type BoxMasterKind =
  | 'customer-personalizations'
  | 'box-purchase-mappings';

export type BoxMasterIssue = {
  code: string;
  message: string;
  rows: number[];
  values: Record<string, unknown>;
};

export type BoxMasterPreviewResponse = {
  kind: BoxMasterKind;
  columns: Record<string, string>;
  source_rows_count: number;
  valid_rows_count: number;
  empty_rows_count: number;
  duplicate_rows_count: number;
  blocking_errors: BoxMasterIssue[];
  warnings: BoxMasterIssue[];
  can_confirm: boolean;
  sample_rows: Record<string, string>[];
  source_file_name: string;
};

export type BoxMasterConfirmResponse = {
  status: 'ok';
  kind: BoxMasterKind;
  source_file_name: string;
  imported_count: number;
  warnings: BoxMasterIssue[];
};

function buildBoxMasterFormData(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  return formData;
}

export async function previewBoxMasterImport(
  kind: BoxMasterKind,
  file: File,
): Promise<BoxMasterPreviewResponse> {
  const { data } = await axiosInstance.post(
    `/industrial-costs/box-masters/${kind}/import/preview`,
    buildBoxMasterFormData(file),
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );

  return data as BoxMasterPreviewResponse;
}

export async function confirmBoxMasterImport(
  kind: BoxMasterKind,
  file: File,
): Promise<BoxMasterConfirmResponse> {
  const { data } = await axiosInstance.post(
    `/industrial-costs/box-masters/${kind}/import/confirm`,
    buildBoxMasterFormData(file),
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );

  return data as BoxMasterConfirmResponse;
}

export async function getIndustrialCostUploads(): Promise<UploadListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/uploads');
  return data as UploadListResponse;
}

export async function getIndustrialCostEconomicMovements(): Promise<EconomicMovementListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/economic-movements');
  return data as EconomicMovementListResponse;
}

export async function deleteIndustrialCostEconomicMovement(
  movementId: string,
): Promise<{ status: 'ok'; deleted: boolean; movement_id: string }> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/economic-movements/${movementId}`,
  );

  return data as { status: 'ok'; deleted: boolean; movement_id: string };
}

export type MovementImportTypeOption = {
  source_value: string;
  suggested_classification_status: 'pending' | 'classified' | 'ignored' | null;
  suggested_economic_type: 'expense' | 'cost' | null;
  suggested_cost_type: 'direct' | 'indirect' | null;
  suggested_source_type_label: string | null;
  movement_count: number;
  amount_total: number;
  is_empty: boolean;
  is_auto_mapped: boolean;
};

export type MovementImportCoverageSummary = {
  total_rows: number;
  rows_with_valid_date: number;
  rows_with_invalid_date: number;
  rows_with_valid_amount: number;
  rows_with_invalid_amount: number;
  rows_with_type_value: number;
  rows_without_type_value: number;
  amount_with_type_value: number;
  amount_without_type_value: number;
};

export type PreviewIndustrialCostMovementsImportResponse = {
  status: 'ok';
  filename: string;
  columns: string[];
  auto_mapping: Record<string, string | null>;
  missing_required_fields: string[];
  preview_rows: Array<Record<string, string | null>>;
  source_granularity: 'day' | 'month' | 'year';
  declared_period_year: number | null;
  declared_period_month: number | null;
  detected_date_min: string | null;
  detected_date_max: string | null;
  detected_type_values: MovementImportTypeOption[];
  suggested_type_mapping: Record<
    string,
    {
      classification_status: 'pending' | 'classified' | 'ignored' | null;
      economic_type: 'expense' | 'cost' | null;
      cost_type: 'direct' | 'indirect' | null;
      source_type_label: string | null;
      is_auto_mapped: boolean;
    }
  >;
  coverage_summary: MovementImportCoverageSummary;
};

export type ConfirmIndustrialCostMovementsImportResponse = {
  status: 'ok';
  upload_id: string;
  filename: string;
  rows_received: number;
  rows_valid: number;
  rows_imported: number;
  classifications_created: number;
  rows_pending_classification: number;
  source_granularity: 'day' | 'month' | 'year';
  declared_period_year: number | null;
  declared_period_month: number | null;
  detected_date_min: string | null;
  detected_date_max: string | null;
  row_errors: Array<{
    fila: number;
    mensaje: string;
  }>;
  persistence_errors: Array<{
    fila: string | number | null;
    mensaje: string;
  }>;
  coverage_summary: MovementImportCoverageSummary | null;
  impact_summary: MovementImportImpactSummary | null;
};

export async function previewIndustrialCostEconomicMovementsImport(
  file: File,
  sourceGranularity: 'day' | 'month' | 'year' = 'day',
  declaredPeriodYear: number | null = null,
  declaredPeriodMonth: number | null = null,
  sheetName: string | null = null,
  headerRowIndex: number | null = null,
): Promise<PreviewIndustrialCostMovementsImportResponse> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('source_granularity', sourceGranularity);

  if (declaredPeriodYear !== null) {
    formData.append('declared_period_year', String(declaredPeriodYear));
  }

  if (declaredPeriodMonth !== null) {
    formData.append('declared_period_month', String(declaredPeriodMonth));
  }

  if (sheetName !== null) {
    formData.append('sheet_name', sheetName);
  }

  if (headerRowIndex !== null) {
    formData.append('header_row_index', String(headerRowIndex));
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/economic-movements/import/preview',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as PreviewIndustrialCostMovementsImportResponse;
}

export async function confirmIndustrialCostEconomicMovementsImport(
  file: File,
  mapping: Record<string, string | null>,
  typeMapping: Record<
    string,
    {
      classification_status: 'pending' | 'classified' | 'ignored' | null;
      economic_type: 'expense' | 'cost' | null;
      cost_type: 'direct' | 'indirect' | null;
      source_type_label: string | null;
      is_auto_mapped?: boolean;
    }
  >,
  uploadMode: MovementUploadMode,
  sourceGranularity: 'day' | 'month' | 'year' = 'day',
  declaredPeriodYear: number | null = null,
  declaredPeriodMonth: number | null = null,
  sheetName: string | null = null,
  headerRowIndex: number | null = null,
): Promise<ConfirmIndustrialCostMovementsImportResponse> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('mapping_json', JSON.stringify(mapping));
  formData.append('type_mapping_json', JSON.stringify(typeMapping));
  formData.append('upload_mode', uploadMode);
  formData.append('source_granularity', sourceGranularity);

  if (declaredPeriodYear !== null) {
    formData.append('declared_period_year', String(declaredPeriodYear));
  }

  if (declaredPeriodMonth !== null) {
    formData.append('declared_period_month', String(declaredPeriodMonth));
  }

  if (sheetName !== null) {
    formData.append('sheet_name', sheetName);
  }

  if (headerRowIndex !== null) {
    formData.append('header_row_index', String(headerRowIndex));
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/economic-movements/import/confirm',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as ConfirmIndustrialCostMovementsImportResponse;
}

export async function getIndustrialCostMovementClassifications(): Promise<MovementClassificationListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/movement-classifications');
  return data as MovementClassificationListResponse;
}

export type UpsertIndustrialCostMovementClassificationPayload = {
  movement_id: string;
  classification_status: 'pending' | 'classified' | 'ignored';
  economic_type?: 'expense' | 'cost' | null;
  cost_type?: 'direct' | 'indirect' | null;
  direct_cost_category?: string | null;
  indirect_cost_category?: string | null;
  notes?: string | null;
  is_manual: boolean;
  confidence?: 'high' | 'medium' | 'low' | null;
};

export async function upsertIndustrialCostMovementClassification(
  payload: UpsertIndustrialCostMovementClassificationPayload,
): Promise<MovementClassification> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/movement-classifications',
    payload,
  );
  return data as MovementClassification;
}

export async function getIndustrialCostDirectCosts(): Promise<DirectCostListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/direct-costs');
  return data as DirectCostListResponse;
}

export async function createIndustrialCostDirectCost(
  payload: CreateDirectCostPayload,
): Promise<DirectCost> {
  const { data } = await axiosInstance.post('/industrial-costs/direct-costs', payload);
  return data as DirectCost;
}

export async function getIndustrialCostDirectCostCategories(): Promise<DirectCostCategoryListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/direct-cost-categories');
  return data as DirectCostCategoryListResponse;
}

export async function createIndustrialCostDirectCostCategory(
  payload: CreateDirectCostCategoryPayload,
): Promise<DirectCostCategory> {
  const { data } = await axiosInstance.post('/industrial-costs/direct-cost-categories', payload);
  return data as DirectCostCategory;
}

export async function updateIndustrialCostDirectCostCategory(
  categoryId: string,
  payload: UpdateDirectCostCategoryPayload,
): Promise<DirectCostCategory> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/direct-cost-categories/${categoryId}`,
    payload,
  );
  return data as DirectCostCategory;
}

export async function deleteIndustrialCostDirectCostCategory(
  categoryId: string,
): Promise<void> {
  await axiosInstance.delete(`/industrial-costs/direct-cost-categories/${categoryId}`);
}

export async function getIndustrialCostDirectCostBlocks(): Promise<DirectCostBlockSummaryListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/direct-costs/blocks');
  return data as DirectCostBlockSummaryListResponse;
}

export async function upsertIndustrialCostDirectCostBlock(
  payload: UpsertDirectCostBlockPayload,
): Promise<DirectCostBlockUpsertResponse> {
  const { data } = await axiosInstance.post('/industrial-costs/direct-costs/block', payload);
  return data as DirectCostBlockUpsertResponse;
}

export async function deleteIndustrialCostDirectCostBlock(
  productId: string,
  periodYear: number,
  periodMonth: number | null,
  directCostDate: string | null,
  sourceGranularity: 'day' | 'month' | 'year' | null,
  sourceType: 'manual',
): Promise<void> {
  await axiosInstance.delete('/industrial-costs/direct-costs/blocks', {
    params: {
      product_id: productId,
      period_year: periodYear,
      period_month: periodMonth,
      direct_cost_date: directCostDate,
      source_granularity: sourceGranularity,
      source_type: sourceType,
    },
  });
}

export async function getIndustrialCostDirectMaterialDerivation(
  productId: string,
  params: {
    period_year: number;
    period_month: number;
  },
): Promise<DirectMaterialDerivationResponse> {
  const { data } = await axiosInstance.get(
    `/industrial-costs/products/${productId}/direct-materials-derivation`,
    { params },
  );
  return data as DirectMaterialDerivationResponse;
}

export async function applyIndustrialCostDirectMaterialDerivation(
  payload: ApplyDirectMaterialDerivationPayload,
): Promise<ApplyDirectMaterialDerivationResponse> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/direct-materials-derivation/apply',
    payload,
  );
  return data as ApplyDirectMaterialDerivationResponse;
}

export async function getIndustrialCostDirectMaterials(): Promise<DirectMaterial[]> {
  const { data } = await axiosInstance.get('/industrial-costs/direct-materials');
  return data as DirectMaterial[];
}

export async function previewIndustrialCostDirectMaterialsImport(
  file: File,
  mapping?: Record<string, string | null>,
): Promise<DirectMaterialImportPreviewResponse> {
  const formData = new FormData();
  formData.append('file', file);

  if (mapping) {
    formData.append('mapping_json', JSON.stringify(mapping));
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/direct-materials/import/preview',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as DirectMaterialImportPreviewResponse;
}

export async function confirmIndustrialCostDirectMaterialsImport(
  file: File,
  mapping: Record<string, string | null>,
  materialTypeMapping: Record<string, string | null>,
): Promise<DirectMaterialImportConfirmResponse> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('mapping_json', JSON.stringify(mapping));
  formData.append('material_type_mapping_json', JSON.stringify(materialTypeMapping));

  const { data } = await axiosInstance.post(
    '/industrial-costs/direct-materials/import/confirm',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as DirectMaterialImportConfirmResponse;
}

export async function getIndustrialCostInventoryCounts(
  countDate: string,
): Promise<InventoryCountListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/inventory-counts', {
    params: {
      count_date: countDate,
    },
  });
  return data as InventoryCountListResponse;
}

export async function getIndustrialCostPreviousInventoryCounts(
  countDate: string,
): Promise<InventoryCountPreviousResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/inventory-counts/previous', {
    params: {
      count_date: countDate,
    },
  });
  return data as InventoryCountPreviousResponse;
}

export async function getIndustrialCostInventoryCountSuggestions(): Promise<InventoryCountSuggestionsResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/inventory-counts/suggestions');
  return data as InventoryCountSuggestionsResponse;
}

export async function previewIndustrialCostInventoryImport(
  file: File,
  countDate: string,
  normalization?: {
    sheet_name?: string | null;
    header_row_index?: number | null;
  },
  mapping?: Record<string, string | null>,
): Promise<InventoryImportPreviewResponse> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('count_date', countDate);

  if (normalization?.sheet_name) {
    formData.append('sheet_name', normalization.sheet_name);
  }

  if (
    normalization?.header_row_index !== undefined &&
    normalization.header_row_index !== null
  ) {
    formData.append(
      'header_row_index',
      String(normalization.header_row_index),
    );
  }

  if (mapping) {
    formData.append(
      'mapping_json',
      JSON.stringify(mapping),
    );
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/inventory-counts/import/preview',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as InventoryImportPreviewResponse;
}

export async function confirmIndustrialCostInventoryImport(
  file: File,
  countDate: string,
  mapping: Record<string, string | null>,
  materialResolution: Record<
    string,
    {
      mode: 'catalog' | 'external';
      material_id?: string;
      external_material_name?: string;
    }
  >,
  normalization?: {
    sheet_name?: string | null;
    header_row_index?: number | null;
  },
): Promise<InventoryImportConfirmResponse> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('count_date', countDate);
  formData.append('mapping_json', JSON.stringify(mapping));
  formData.append(
    'material_resolution_json',
    JSON.stringify(materialResolution),
  );

  if (normalization?.sheet_name) {
    formData.append('sheet_name', normalization.sheet_name);
  }

  if (
    normalization?.header_row_index !== undefined &&
    normalization.header_row_index !== null
  ) {
    formData.append(
      'header_row_index',
      String(normalization.header_row_index),
    );
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/inventory-counts/import/confirm',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as InventoryImportConfirmResponse;
}

export async function createIndustrialCostInventoryCount(
  payload: CreateInventoryCountPayload,
): Promise<InventoryCount> {
  const { data } = await axiosInstance.post('/industrial-costs/inventory-counts', payload);
  return data as InventoryCount;
}

export async function updateIndustrialCostInventoryCount(
  countId: string,
  payload: UpdateInventoryCountPayload,
): Promise<InventoryCount> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/inventory-counts/${countId}`,
    payload,
  );
  return data as InventoryCount;
}

export async function deleteIndustrialCostInventoryCount(
  countId: string,
): Promise<{ status: string; deleted: boolean; count_id: string }> {
  const { data } = await axiosInstance.delete(`/industrial-costs/inventory-counts/${countId}`);
  return data as { status: string; deleted: boolean; count_id: string };
}

// =========================================================
// Inventory spaces / Warehouses, maps and configured cells
// =========================================================

export async function getIndustrialCostWarehouses(): Promise<Warehouse[]> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/inventory-spaces/warehouses',
  );

  return data as Warehouse[];
}

export async function createIndustrialCostWarehouse(
  payload: CreateWarehousePayload,
): Promise<Warehouse> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/inventory-spaces/warehouses',
    payload,
  );

  return data as Warehouse;
}

export async function updateIndustrialCostWarehouse(
  warehouseId: string,
  payload: UpdateWarehousePayload,
): Promise<Warehouse> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/inventory-spaces/warehouses/${warehouseId}`,
    payload,
  );

  return data as Warehouse;
}

export async function getIndustrialCostWarehouseMaps(
  warehouseId: string,
): Promise<WarehouseMap[]> {
  const { data } = await axiosInstance.get(
    `/industrial-costs/inventory-spaces/warehouses/${warehouseId}/maps`,
  );

  return data as WarehouseMap[];
}

export async function createIndustrialCostWarehouseMap(
  payload: CreateWarehouseMapPayload,
): Promise<WarehouseMap> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/inventory-spaces/maps',
    payload,
  );

  return data as WarehouseMap;
}

export async function getIndustrialCostWarehouseMapDetail(
  warehouseMapId: string,
): Promise<WarehouseMapDetailResponse> {
  const { data } = await axiosInstance.get(
    `/industrial-costs/inventory-spaces/maps/${warehouseMapId}`,
  );

  return data as WarehouseMapDetailResponse;
}

export async function updateIndustrialCostWarehouseMap(
  warehouseMapId: string,
  payload: UpdateWarehouseMapPayload,
): Promise<WarehouseMap> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/inventory-spaces/maps/${warehouseMapId}`,
    payload,
  );

  return data as WarehouseMap;
}

export async function replaceIndustrialCostWarehouseMapCells(
  warehouseMapId: string,
  payload: ReplaceWarehouseMapCellsPayload,
): Promise<WarehouseMapCellsReplaceResponse> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/inventory-spaces/maps/${warehouseMapId}/cells`,
    payload,
  );

  return data as WarehouseMapCellsReplaceResponse;
}

export async function activateIndustrialCostWarehouseMap(
  warehouseMapId: string,
): Promise<WarehouseMapActivateResponse> {
  const { data } = await axiosInstance.post(
    `/industrial-costs/inventory-spaces/maps/${warehouseMapId}/activate`,
  );

  return data as WarehouseMapActivateResponse;
}

export async function getIndustrialCostWarehouseLocationMaterialAssignments(
  warehouseMapId: string,
): Promise<WarehouseLocationMaterialAssignment[]> {
  const { data } = await axiosInstance.get(
    `/industrial-costs/inventory-spaces/maps/${warehouseMapId}/material-assignments`,
  );

  return data as WarehouseLocationMaterialAssignment[];
}

export async function upsertIndustrialCostWarehouseLocationMaterialAssignment(
  warehouseLocationId: string,
  payload: UpsertWarehouseLocationMaterialAssignmentPayload,
): Promise<WarehouseLocationMaterialAssignment> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/inventory-spaces/locations/${warehouseLocationId}/material-assignment`,
    payload,
  );

  return data as WarehouseLocationMaterialAssignment;
}

export async function deleteIndustrialCostWarehouseLocationMaterialAssignment(
  warehouseLocationId: string,
): Promise<{
  status: string;
  deleted: boolean;
  warehouse_location_id: string;
}> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/inventory-spaces/locations/${warehouseLocationId}/material-assignment`,
  );

  return data as {
    status: string;
    deleted: boolean;
    warehouse_location_id: string;
  };
}

export async function createIndustrialCostDirectMaterial(
  payload: CreateDirectMaterialPayload,
): Promise<DirectMaterial> {
  const { data } = await axiosInstance.post('/industrial-costs/direct-materials', payload);
  return data as DirectMaterial;
}

export async function updateIndustrialCostDirectMaterial(
  materialId: string,
  payload: UpdateDirectMaterialPayload,
): Promise<DirectMaterial> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/direct-materials/${materialId}`,
    payload,
  );
  return data as DirectMaterial;
}

export async function deleteIndustrialCostDirectMaterial(
  materialId: string,
): Promise<{ status: string; deleted: boolean; material_id: string }> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/direct-materials/${materialId}`,
  );
  return data as { status: string; deleted: boolean; material_id: string };
}

export async function getIndustrialCostDirectMaterialEntries(): Promise<DirectMaterialEntryListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/direct-material-entries');
  return data as DirectMaterialEntryListResponse;
}

export async function createIndustrialCostDirectMaterialEntry(
  payload: CreateDirectMaterialEntryPayload,
): Promise<DirectMaterialEntry> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/direct-material-entries',
    payload,
  );
  return data as DirectMaterialEntry;
}

export async function updateIndustrialCostDirectMaterialEntry(
  entryId: string,
  payload: UpdateDirectMaterialEntryPayload,
): Promise<DirectMaterialEntry> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/direct-material-entries/${entryId}`,
    payload,
  );
  return data as DirectMaterialEntry;
}

export async function deleteIndustrialCostDirectMaterialEntry(
  entryId: string,
): Promise<{ status: string; deleted: boolean; entry_id: string }> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/direct-material-entries/${entryId}`,
  );

  return data as { status: string; deleted: boolean; entry_id: string };
}

export async function previewIndustrialCostDirectMaterialEntriesImport(
  file: File,
  mapping?: Record<string, string | null>,
  materialResolution?: Record<string, string | null>,
  normalization?: {
    sheet_name?: string | null;
    header_row_index?: number | null;
  },
): Promise<DirectMaterialEntryImportPreviewResponse> {
  const formData = new FormData();
  formData.append('file', file);

  if (mapping) {
    formData.append('mapping_json', JSON.stringify(mapping));
  }

  if (materialResolution) {
    formData.append('material_resolution_json', JSON.stringify(materialResolution));
  }

  if (normalization?.sheet_name) {
    formData.append('sheet_name', normalization.sheet_name);
  }

  if (normalization?.header_row_index !== undefined && normalization.header_row_index !== null) {
    formData.append('header_row_index', String(normalization.header_row_index));
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/direct-material-entries/import/preview',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as DirectMaterialEntryImportPreviewResponse;
}

export async function confirmIndustrialCostDirectMaterialEntriesImport(
  file: File,
  mapping: Record<string, string | null>,
  materialResolution: Record<string, string | null>,
  normalization?: {
    sheet_name?: string | null;
    header_row_index?: number | null;
  },
): Promise<DirectMaterialEntryImportConfirmResponse> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('mapping_json', JSON.stringify(mapping));
  formData.append('material_resolution_json', JSON.stringify(materialResolution));

  if (normalization?.sheet_name) {
    formData.append('sheet_name', normalization.sheet_name);
  }

  if (normalization?.header_row_index !== undefined && normalization.header_row_index !== null) {
    formData.append('header_row_index', String(normalization.header_row_index));
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/direct-material-entries/import/confirm',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as DirectMaterialEntryImportConfirmResponse;
}

export async function getIndustrialCostDirectMaterialValuations(): Promise<DirectMaterialValuationListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/direct-material-valuations');
  return data as DirectMaterialValuationListResponse;
}

export async function getIndustrialCostDirectMaterialMonthlyValuations(params?: {
  period_year?: number;
  period_month?: number;
}): Promise<DirectMaterialMonthlyValuationListResponse> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/direct-material-monthly-valuations',
    { params },
  );

  return data as DirectMaterialMonthlyValuationListResponse;
}

export async function getIndustrialCostMaterialControl(params: {
  period_year: number;
  period_month: number;
}): Promise<MaterialControlResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/material-control', {
    params,
  });

  return data as MaterialControlResponse;
}

export async function getIndustrialCostMaterialStockProjection(): Promise<
  MaterialStockProjectionResponse
> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/material-stock-projection',
  );

  return data as MaterialStockProjectionResponse;
}

export async function createIndustrialCostDirectMaterialValuation(
  payload: CreateDirectMaterialValuationPayload,
): Promise<DirectMaterialValuation> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/direct-material-valuations',
    payload,
  );
  return data as DirectMaterialValuation;
}

export async function updateIndustrialCostDirectMaterialValuation(
  valuationId: string,
  payload: UpdateDirectMaterialValuationPayload,
): Promise<DirectMaterialValuation> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/direct-material-valuations/${valuationId}`,
    payload,
  );
  return data as DirectMaterialValuation;
}

export async function deleteIndustrialCostDirectMaterialValuation(
  valuationId: string,
): Promise<{ status: string; deleted: boolean; valuation_id: string }> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/direct-material-valuations/${valuationId}`,
  );
  return data as { status: string; deleted: boolean; valuation_id: string };
}

export async function getIndustrialCostTechnicalConsumptionRules(): Promise<
  TechnicalConsumptionRule[]
> {
  const { data } = await axiosInstance.get('/industrial-costs/technical-consumption-rules');
  return data as TechnicalConsumptionRule[];
}

export async function getIndustrialCostTechnicalConsumptionImportPending(): Promise<
  TechnicalConsumptionImportPendingListResponse
> {
  const { data } = await axiosInstance.get(
    '/industrial-costs/technical-consumption-rules/import-pending',
    {
      params: {
        status_filter: 'pending',
      },
    },
  );

  return data as TechnicalConsumptionImportPendingListResponse;
}

export async function discardIndustrialCostTechnicalConsumptionImportPending(
  pendingId: string,
): Promise<TechnicalConsumptionImportPending> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/technical-consumption-rules/import-pending/${pendingId}/discard`,
  );

  return data as TechnicalConsumptionImportPending;
}

export async function resolveIndustrialCostTechnicalConsumptionImportPending(
  pendingId: string,
  payload: ResolveTechnicalConsumptionImportPendingPayload,
): Promise<TechnicalConsumptionImportPending> {
  const { data } = await axiosInstance.post(
    `/industrial-costs/technical-consumption-rules/import-pending/${pendingId}/resolve`,
    payload,
  );

  return data as TechnicalConsumptionImportPending;
}

export async function previewIndustrialCostTechnicalConsumptionRulesImport(
  file: File,
  mapping?: Record<string, string | null>,
  productResolution?: Record<string, string | null>,
  materialResolution?: Record<string, string | null>,
  normalization?: {
    sheet_name?: string | null;
    header_row_index?: number | null;
  },
): Promise<TechnicalConsumptionImportPreviewResponse> {
  const formData = new FormData();
  formData.append('file', file);

  if (mapping) {
    formData.append('mapping_json', JSON.stringify(mapping));
  }

  if (productResolution) {
    formData.append('product_resolution_json', JSON.stringify(productResolution));
  }

  if (materialResolution) {
    formData.append('material_resolution_json', JSON.stringify(materialResolution));
  }

  if (normalization?.sheet_name) {
    formData.append('sheet_name', normalization.sheet_name);
  }

  if (
    normalization?.header_row_index !== undefined &&
    normalization.header_row_index !== null
  ) {
    formData.append(
      'header_row_index',
      String(normalization.header_row_index),
    );
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/technical-consumption-rules/import/preview',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as TechnicalConsumptionImportPreviewResponse;
}

export async function confirmIndustrialCostTechnicalConsumptionRulesImport(
  file: File,
  mapping: Record<string, string | null>,
  productResolution: Record<string, string | null>,
  materialResolution: Record<string, string | null>,
  materialTypeMapping: Record<string, string | null>,
  quantityDivisor: number = 1,
  normalization?: {
    sheet_name?: string | null;
    header_row_index?: number | null;
  },
  replaceExisting: boolean = false,
): Promise<TechnicalConsumptionImportConfirmResponse> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('mapping_json', JSON.stringify(mapping));
  formData.append('product_resolution_json', JSON.stringify(productResolution));
  formData.append('material_resolution_json', JSON.stringify(materialResolution));
  formData.append('material_type_mapping_json', JSON.stringify(materialTypeMapping));
  formData.append('quantity_divisor', String(quantityDivisor));
  formData.append('replace_existing', String(replaceExisting));

  if (normalization?.sheet_name) {
    formData.append('sheet_name', normalization.sheet_name);
  }

  if (
    normalization?.header_row_index !== undefined &&
    normalization.header_row_index !== null
  ) {
    formData.append(
      'header_row_index',
      String(normalization.header_row_index),
    );
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/technical-consumption-rules/import/confirm',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as TechnicalConsumptionImportConfirmResponse;
}

export async function createIndustrialCostTechnicalConsumptionRule(
  payload: CreateTechnicalConsumptionRulePayload,
): Promise<TechnicalConsumptionRule> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/technical-consumption-rules',
    payload,
  );
  return data as TechnicalConsumptionRule;
}

export async function updateIndustrialCostTechnicalConsumptionRule(
  ruleId: string,
  payload: UpdateTechnicalConsumptionRulePayload,
): Promise<TechnicalConsumptionRule> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/technical-consumption-rules/${ruleId}`,
    payload,
  );
  return data as TechnicalConsumptionRule;
}

export async function deleteIndustrialCostTechnicalConsumptionRule(
  ruleId: string,
): Promise<{ status: string; deleted: boolean; rule_id: string }> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/technical-consumption-rules/${ruleId}`,
  );
  return data as { status: string; deleted: boolean; rule_id: string };
}

export async function getIndustrialCostPrimaryAllocations(): Promise<PrimaryAllocationListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/primary-allocations');
  return data as PrimaryAllocationListResponse;
}

export async function getIndustrialCostPrimaryAllocationsByMovement(
  movementId: string,
): Promise<PrimaryAllocationListResponse> {
  const { data } = await axiosInstance.get(
    `/industrial-costs/primary-allocations/by-movement/${movementId}`,
  );
  return data as PrimaryAllocationListResponse;
}

export async function createIndustrialCostPrimaryAllocation(
  payload: CreatePrimaryAllocationPayload,
): Promise<PrimaryAllocation> {
  const { data } = await axiosInstance.post('/industrial-costs/primary-allocations', payload);
  return data as PrimaryAllocation;
}

export async function deleteIndustrialCostPrimaryAllocation(
  allocationId: string,
): Promise<void> {
  await axiosInstance.delete(`/industrial-costs/primary-allocations/${allocationId}`);
}

export async function getIndustrialCostSecondaryAllocations(): Promise<SecondaryAllocationListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/secondary-allocations');
  return data as SecondaryAllocationListResponse;
}

export async function getIndustrialCostSecondaryAllocationsBySourceStage(
  sourceStageId: string,
): Promise<SecondaryAllocationListResponse> {
  const { data } = await axiosInstance.get(
    `/industrial-costs/secondary-allocations/by-source-stage/${sourceStageId}`,
  );
  return data as SecondaryAllocationListResponse;
}

export async function createIndustrialCostSecondaryAllocation(
  payload: CreateSecondaryAllocationPayload,
): Promise<SecondaryAllocation> {
  const { data } = await axiosInstance.post('/industrial-costs/secondary-allocations', payload);
  return data as SecondaryAllocation;
}

export async function deleteIndustrialCostSecondaryAllocation(
  allocationId: string,
): Promise<void> {
  await axiosInstance.delete(`/industrial-costs/secondary-allocations/${allocationId}`);
}

export async function getIndustrialCostProductionVolumes(): Promise<ProductionVolumeListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/production-volumes');
  return data as ProductionVolumeListResponse;
}

// IND-055: el Panel no necesita los partes enteros (unos 10 MB), solo sus sumas.
export async function getPlantPanelProduction(): Promise<PanelProductionRow[]> {
  const { data } = await axiosInstance.get('/industrial-costs/production-volumes/panel');
  return data as PanelProductionRow[];
}

export async function getIndustrialCostProductionVolumesByProduct(
  productId: string,
): Promise<ProductionVolumeListResponse> {
  const { data } = await axiosInstance.get(
    `/industrial-costs/production-volumes/by-product/${productId}`,
  );
  return data as ProductionVolumeListResponse;
}

export async function createIndustrialCostProductionVolume(
  payload: CreateProductionVolumePayload,
): Promise<ProductionVolume> {
  const { data } = await axiosInstance.post('/industrial-costs/production-volumes', payload);
  return data as ProductionVolume;
}

export async function updateIndustrialCostProductionVolume(
  volumeId: string,
  payload: UpdateProductionVolumePayload,
): Promise<ProductionVolume> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/production-volumes/${volumeId}`,
    payload,
  );

  return data as ProductionVolume;
}

export async function deleteIndustrialCostProductionVolume(
  volumeId: string,
): Promise<void> {
  await axiosInstance.delete(`/industrial-costs/production-volumes/${volumeId}`);
}

export async function previewIndustrialCostProductionImport(
  file: File,
  mapping?: Record<string, string | null>,
  sourceGranularity: 'day' | 'month' | 'year' | null = null,
  declaredPeriodYear: number | null = null,
  declaredPeriodMonth: number | null = null,
  sheetName: string | null = null,
  headerRowIndex: number | null = null,
): Promise<ProductionImportPreview> {
  const formData = new FormData();
  formData.append('file', file);

  if (mapping) {
    formData.append('mapping_json', JSON.stringify(mapping));
  }

  if (sourceGranularity) {
    formData.append('source_granularity', sourceGranularity);
  }

  if (declaredPeriodYear !== null) {
    formData.append('declared_period_year', String(declaredPeriodYear));
  }

  if (declaredPeriodMonth !== null) {
    formData.append('declared_period_month', String(declaredPeriodMonth));
  }

  if (sheetName !== null) {
    formData.append('sheet_name', sheetName);
  }

  if (headerRowIndex !== null) {
    formData.append('header_row_index', String(headerRowIndex));
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/production-volumes/import/preview',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as ProductionImportPreview;
}

export async function confirmIndustrialCostProductionImport(
  file: File,
  mapping: Record<string, string | null>,
  productResolution: Record<string, string>,
  lineResolution: Record<string, string>,
  uploadMode: ProductionUploadMode,
  sourceGranularity: 'day' | 'month' | 'year' | null = null,
  declaredPeriodYear: number | null = null,
  declaredPeriodMonth: number | null = null,
  sheetName: string | null = null,
  headerRowIndex: number | null = null,
): Promise<ProductionImportSummary> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('mapping_json', JSON.stringify(mapping));
  formData.append('product_resolution_json', JSON.stringify(productResolution));
  formData.append('line_resolution_json', JSON.stringify(lineResolution));
  formData.append('upload_mode', uploadMode);

  if (sourceGranularity) {
    formData.append('source_granularity', sourceGranularity);
  }

  if (declaredPeriodYear !== null) {
    formData.append('declared_period_year', String(declaredPeriodYear));
  }

  if (declaredPeriodMonth !== null) {
    formData.append('declared_period_month', String(declaredPeriodMonth));
  }

  if (sheetName !== null) {
    formData.append('sheet_name', sheetName);
  }

  if (headerRowIndex !== null) {
    formData.append('header_row_index', String(headerRowIndex));
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/production-volumes/import/confirm',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as ProductionImportSummary;
}

export async function getIndustrialCostFinalAllocationRules(): Promise<FinalAllocationRuleListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/final-allocation-rules');
  return data as FinalAllocationRuleListResponse;
}

export async function createIndustrialCostFinalAllocationRule(
  payload: CreateFinalAllocationRulePayload,
): Promise<FinalAllocationRule> {
  const { data } = await axiosInstance.post('/industrial-costs/final-allocation-rules', payload);
  return data as FinalAllocationRule;
}

export async function deleteIndustrialCostFinalAllocationRule(
  ruleId: string,
): Promise<void> {
  await axiosInstance.delete(`/industrial-costs/final-allocation-rules/${ruleId}`);
}

export async function getIndustrialCostStageProductApplicabilities(): Promise<StageProductApplicabilityListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/stage-product-applicabilities');
  return data as StageProductApplicabilityListResponse;
}

export async function createIndustrialCostStageProductApplicability(
  payload: CreateStageProductApplicabilityPayload,
): Promise<StageProductApplicability> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/stage-product-applicabilities',
    payload,
  );
  return data as StageProductApplicability;
}

export async function deleteIndustrialCostStageProductApplicability(
  applicabilityId: string,
): Promise<void> {
  await axiosInstance.delete(
    `/industrial-costs/stage-product-applicabilities/${applicabilityId}`,
  );
}

export async function getIndustrialCostCostRuns(): Promise<CostRunListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/cost-runs');
  return data as CostRunListResponse;
}

export async function executeIndustrialCostRun(
  payload: ExecuteCostRunPayload,
): Promise<CostRun> {
  const { data } = await axiosInstance.post('/industrial-costs/cost-runs/execute', payload);
  return data as CostRun;
}

export async function getIndustrialCostCostResults(): Promise<CostResultListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/cost-results');
  return data as CostResultListResponse;
}

export async function getIndustrialCostCurrentCostResults(
  periodYear: number,
  periodMonth: number | null,
): Promise<CurrentCostResultListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/cost-results/current', {
    params: {
      period_year: periodYear,
      period_month: periodMonth,
    },
  });
  return data as CurrentCostResultListResponse;
}

export async function getIndustrialCostCostResultsByRun(
  runId: string,
): Promise<CostResultListResponse> {
  const { data } = await axiosInstance.get(
    `/industrial-costs/cost-results/by-run/${runId}`,
  );
  return data as CostResultListResponse;
}

export async function getIndustrialCostLaborModuleConfig(): Promise<LaborModuleConfig> {
  const { data } = await axiosInstance.get('/industrial-costs/labor/config');
  return data as LaborModuleConfig;
}

export async function updateIndustrialCostLaborModuleConfig(
  payload: UpdateLaborModuleConfigPayload,
): Promise<LaborModuleConfig> {
  const { data } = await axiosInstance.put('/industrial-costs/labor/config', payload);
  return data as LaborModuleConfig;
}

export async function getIndustrialCostLaborStageCosts(params: {
  period_year: number;
  period_month: number;
}): Promise<LaborStageCostListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/labor/stage-costs', {
    params,
  });
  return data as LaborStageCostListResponse;
}

export async function createIndustrialCostLaborStageCost(
  payload: CreateLaborStageCostPayload,
): Promise<LaborStageCost> {
  const { data } = await axiosInstance.post('/industrial-costs/labor/stage-costs', payload);
  return data as LaborStageCost;
}

export async function updateIndustrialCostLaborStageCost(
  stageCostId: string,
  payload: UpdateLaborStageCostPayload,
): Promise<LaborStageCost> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/labor/stage-costs/${stageCostId}`,
    payload,
  );
  return data as LaborStageCost;
}

export async function deleteIndustrialCostLaborStageCost(
  stageCostId: string,
): Promise<{ status: string; deleted: boolean; stage_cost_id: string }> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/labor/stage-costs/${stageCostId}`,
  );
  return data as { status: string; deleted: boolean; stage_cost_id: string };
}

export async function getIndustrialCostLaborProductRates(): Promise<LaborProductRateListResponse> {
  const { data } = await axiosInstance.get('/industrial-costs/labor/product-rates');
  return data as LaborProductRateListResponse;
}

export async function previewIndustrialCostLaborProductRatesImport(
  file: File,
  mapping?: Record<string, string | null>,
  productResolution?: Record<string, string | null>,
  stageResolution?: Record<string, string | null>,
): Promise<LaborProductRateImportPreviewResponse> {
  const formData = new FormData();
  formData.append('file', file);

  if (mapping) {
    formData.append('mapping_json', JSON.stringify(mapping));
  }

  if (productResolution) {
    formData.append('product_resolution_json', JSON.stringify(productResolution));
  }

  if (stageResolution) {
    formData.append('stage_resolution_json', JSON.stringify(stageResolution));
  }

  const { data } = await axiosInstance.post(
    '/industrial-costs/labor/product-rates/import/preview',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as LaborProductRateImportPreviewResponse;
}

export async function confirmIndustrialCostLaborProductRatesImport(
  file: File,
  mapping: Record<string, string | null>,
  productResolution: Record<string, string | null>,
  stageResolution: Record<string, string | null>,
): Promise<LaborProductRateImportConfirmResponse> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('mapping_json', JSON.stringify(mapping));
  formData.append('product_resolution_json', JSON.stringify(productResolution));
  formData.append('stage_resolution_json', JSON.stringify(stageResolution));

  const { data } = await axiosInstance.post(
    '/industrial-costs/labor/product-rates/import/confirm',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data as LaborProductRateImportConfirmResponse;
}

export async function createIndustrialCostLaborProductRate(
  payload: CreateLaborProductRatePayload,
): Promise<LaborProductRate> {
  const { data } = await axiosInstance.post('/industrial-costs/labor/product-rates', payload);
  return data as LaborProductRate;
}

export async function updateIndustrialCostLaborProductRate(
  rateId: string,
  payload: UpdateLaborProductRatePayload,
): Promise<LaborProductRate> {
  const { data } = await axiosInstance.put(
    `/industrial-costs/labor/product-rates/${rateId}`,
    payload,
  );
  return data as LaborProductRate;
}

export async function deleteIndustrialCostLaborProductRate(
  rateId: string,
): Promise<{ status: string; deleted: boolean; rate_id: string }> {
  const { data } = await axiosInstance.delete(
    `/industrial-costs/labor/product-rates/${rateId}`,
  );
  return data as { status: string; deleted: boolean; rate_id: string };
}

export async function getIndustrialCostLaborResults(params: {
  period_year: number;
  period_month: number;
}): Promise<LaborResultSummary> {
  const { data } = await axiosInstance.get('/industrial-costs/labor/results', {
    params,
  });
  return data as LaborResultSummary;
}

export type PerformanceAnalysisTotalsInput = {
  closed_orders_count?: number | null;
  reports_count?: number | null;
  real_duration_minutes?: number | null;
  estimated_duration_minutes?: number | null;
  estimated_orders_count?: number | null;
  deviation_pct?: number | null;
  deviation_minutes?: number | null;
  within_tolerance_pct?: number | null;
  within_tolerance_count?: number | null;
  orders_without_estimation_count?: number | null;
  stop_duration_minutes?: number | null;
  stops_count?: number | null;
  stops_per_order?: number | null;
  average_stop_duration_minutes?: number | null;
};

export type PerformanceAnalysisLineInput = {
  line_or_center?: string | null;
  closed_orders_count?: number | null;
  real_duration_minutes?: number | null;
  estimated_duration_minutes?: number | null;
  deviation_pct?: number | null;
  within_tolerance_pct?: number | null;
  stop_duration_minutes?: number | null;
  stops_count?: number | null;
  stops_per_order?: number | null;
};

export type PerformanceAnalysisShiftInput = {
  shift: string;
  shift_label: string;
  closed_orders_count?: number | null;
  real_duration_minutes?: number | null;
  estimated_duration_minutes?: number | null;
  deviation_pct?: number | null;
  deviation_minutes?: number | null;
  within_tolerance_pct?: number | null;
  stop_duration_minutes?: number | null;
  stops_count?: number | null;
  stops_per_order?: number | null;
  average_stop_duration_minutes?: number | null;
};

export type PerformanceAnalysisOperatorInput = {
  operator_number: string;
  closed_orders_count?: number | null;
  real_duration_minutes?: number | null;
  estimated_duration_minutes?: number | null;
  deviation_pct?: number | null;
  deviation_minutes?: number | null;
  within_tolerance_pct?: number | null;
  stop_duration_minutes?: number | null;
  stops_count?: number | null;
  stops_per_order?: number | null;
  average_stop_duration_minutes?: number | null;
};

export type PerformanceAnalysisStopReasonInput = {
  reason_label: string;
  stops_count: number;
  stop_duration_minutes: number;
};

export type PerformanceAnalysisRequest = {
  period_label: string;
  current: PerformanceAnalysisTotalsInput;
  previous?: PerformanceAnalysisTotalsInput | null;
  by_line: PerformanceAnalysisLineInput[];
  by_shift?: PerformanceAnalysisShiftInput[];
  by_operator?: PerformanceAnalysisOperatorInput[];
  top_stop_reasons?: PerformanceAnalysisStopReasonInput[];
};

export async function analyzeIndustrialCostProductionPerformance(
  payload: PerformanceAnalysisRequest,
): Promise<{ analysis: string }> {
  const { data } = await axiosInstance.post(
    '/industrial-costs/production-reports/performance/analyze',
    payload,
  );
  return data as { analysis: string };
}